export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Wan 2.6 视频生成器 - 新一代多模态AI视频创作平台',
        pageDescription:
            '体验Wan 2.6旗舰级多模态 AI 视频生成模型，不仅支持生成电影级 1080p 分辨率的视频，更实现了 原生音视频同步（Native Audio-Visual Sync）的突破，能够一次性生成画面与匹配的音效、人声。在WeryAI平台免费试用。',
        pageKeywords:
            'Wan 2.6, AI视频生成器,多模态 AI 视频生成模型,原生音视频同步, 电影级 1080p 分辨率, 智能分镜功能, 免费AI视频, 微鲤AI, 视频制作',

        // 生成器部分
        generatorTitle: 'Wan 2.6 旗舰级多模态 AI 视频生成模型',
        short_title: '多模态AI视频模型',
        generatorDescription:
            'Wan 2.6 是阿里云通义万相（Wanx）团队最新发布的旗舰级多模态 AI 视频生成模型。作为 Wan 系列的重大升级版本，它不仅支持生成电影级 1080p 分辨率的视频，更实现了 原生音视频同步（Native Audio-Visual Sync）的突破，能够一次性生成画面与匹配的音效、人声。Wan 2.6 专为解决长视频叙事难题而生，其独有的智能分镜功能支持长达 15 秒的连贯多镜头创作，是创作者实现“从剧本到成片”的终极工具。快来 微鲤AI 免费体验 Wan 2.6，感受“有声有色”的 AI 创作新纪元！',
        generatorDescriptionHighlight1:
            'Wan 2.6 模型现已集成到 微鲤AI 视频生成器中，可生成逼真的视频',
        generatorDescriptionText2: '。点击此处',
        generatorDescriptionHighlight2: '免费试用 Wan 2.6',
        generatorDescriptionEnd: '！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 核心功能特性',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: '原生音视频同步生成',
        nativeAudioIntegrationDescription:
            'Wan 2.6 打破了视觉与听觉的界限，在生成视频画面的同时，能够根据内容自动生成精准同步的音效（如脚步声、雨声）甚至角色对白口型，无需后期配音即可获得完整的视听素材。',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: '智能多镜头叙事',
        enhancedDynamicEffectsDescription:
            '模型具备极强的语义理解能力，能自动将一段复杂的长提示词拆解为多个分镜（如全景接特写），并确保角色形象、场景光影在不同镜头间保持高度一致，单次生成即可讲述一个完整的小故事。',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: '角色表演复刻',
        preciseCameraControlDescription:
            '通过“视频生视频”功能，用户可以上传一段真人表演视频作为参考，Wan 2.6 能将原视频中的动作幅度、面部表情甚至运镜节奏，精准迁移到新生成的虚拟角色（如动漫人物或3D模型）身上，实现“AI 动作捕捉”。',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: '15 秒长视频连贯生成',
        enhancedVisualRealismDescription:
            '支持生成长达 15 秒的 1080p/24fps 高清视频，相比传统模型的短片段，Wan 2.6 提供了更充裕的时间来展现复杂的动作逻辑和环境变化，且全程保持画质无崩坏。',

        // 如何使用部分
        howToUseTitle: '如何在 微鲤AI 上使用 Wan 2.6',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Wan 2.6 模型',
        step2Title: '输入内容',
        step2Description:
            '在文本框中描述您想要的画面，或上传参考图片/视频以启用“图生视频”或“角色复刻”功能。',
        step3Title: '生成视频',
        step3Description:
            '设置参数（如 16:9 比例、15秒时长），点击“生成”按钮，稍等片刻即可预览并下载您的有声大片。',

        // YouTube 视频部分
        youtubeTitle: '关于 Wan 2.6 视频模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Wan 2.6 AI 视频模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI 视频生成器',
        sora2Title: 'OpenAI Sora-2 AI 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: 'Wan 2.6是什么?',
        faq1Answer:
            'Wan 2.6 是阿里云推出的最新一代 AI 视频生成模型，具备电影级画质、原生音画同步生成以及智能多镜头叙事等突破性功能。',
        faq2Question: 'Wan 2.6 最大的特色是什么？',
        faq2Answer:
            '最大的特色是“原生音视频同步”，它不仅生成视频，还能同时生成匹配的环境音和人声，省去了后期配音的繁琐步骤。此外，它的多镜头一致性也非常出色。',
        faq3Question: '在 微鲤AI 上使用 Wan 2.6 是免费的吗？?',
        faq3Answer:
            '微鲤AI 为注册用户提供免费的积分额度，可用于体验 Wan 2.6 的基础功能。生成高清、长时长（15秒）视频可能需要消耗更多积分或升级为 Pro 会员。',
        faq4Question: 'Wan 2.6 生成的视频有多长？',
        faq4Answer:
            '目前支持生成 5秒、10秒 和最长 15秒 的视频片段。通过多镜头功能，单次生成的 15 秒视频可以包含丰富的情节转折。',
        faq5Question: '它支持哪些输入方式？',
        faq5Answer:
            '支持“文生视频”（Text-to-Video）、“图生视频”（Image-to-Video）以及“视频生视频”（Video-to-Video/角色复刻），满足从灵感到素材的全方位创作需求。',
        faq6Question: 'Wan 2.6 和 Wan 2.5 有什么区别？',
        faq6Answer:
            'Wan 2.6 是全面升级的商业级版本（API），画质从 720p 提升至 1080p，增加了音频生成能力，并大幅优化了动作的流畅度和指令遵循度。',
        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Wan 2.6，将您的创意转化为精彩视频',
        ctaButton: '立即体验 Wan 2.6',
        ctaDisclaimer: '无须信用卡，注册即可使用',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoReload: '重新加载',
    },
    en: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 Video Generator - Next-Gen Multimodal AI Video Creation Platform',
        pageDescription:
            'Try Wan 2.6, a flagship multimodal AI video generation model. It delivers cinematic 1080p video and a breakthrough in Native Audio-Visual Sync—generating visuals together with matching sound effects and voices in one go. Free to try on 微鲤AI.',
        pageKeywords:
            'Wan 2.6, AI video generator, multimodal AI video model, native audio-visual sync, cinematic 1080p, intelligent storyboarding, free AI video, 微鲤AI, video creation',

        // 生成器部分
        generatorTitle: 'Wan 2.6 Flagship Multimodal AI Video Generation Model',
        short_title: 'Multimodal AI Video Model',
        generatorDescription:
            'Wan 2.6 is the latest flagship multimodal AI video generation model released by Alibaba Cloud’s Tongyi Wanxiang (Wanx) team. As a major upgrade in the Wan series, it not only supports cinematic 1080p output but also achieves a breakthrough in Native Audio-Visual Sync—generating visuals along with matched sound effects and voices in a single pass. Built to tackle long-form storytelling, Wan 2.6 features intelligent multi-shot storyboarding that enables up to 15 seconds of coherent, multi-camera creation, helping creators go from script to final cut. Try Wan 2.6 for free on 微鲤AI and step into a new era of “video with sound, made by AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 is now integrated into the 微鲤AI video generator to create realistic videos',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'try Wan 2.6 for free',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 Key Features',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Native Audio-Visual Sync Generation',
        nativeAudioIntegrationDescription:
            'Wan 2.6 breaks the boundary between sight and sound—while generating the video, it can automatically create precisely synchronized audio (e.g., footsteps, rain) and even character dialogue lip-sync, delivering complete audiovisual assets without post-dubbing.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Intelligent Multi-Shot Storytelling',
        enhancedDynamicEffectsDescription:
            'With strong semantic understanding, the model can decompose a complex long prompt into multiple shots (e.g., wide to close-up) and keep character identity, scenes, and lighting highly consistent across shots—telling a complete mini story in a single generation.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performance & Motion Re-enactment',
        preciseCameraControlDescription:
            'Using “video-to-video”, you can upload a real performance clip as reference. Wan 2.6 can accurately transfer the motion range, facial expressions, and even camera rhythm to a newly generated virtual character (e.g., anime or 3D), enabling “AI motion capture”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Coherent 15-Second Long Video Generation',
        enhancedVisualRealismDescription:
            'Generate up to 15 seconds of 1080p/24fps HD video. Compared with short clips from traditional models, Wan 2.6 gives more time to portray complex actions and environmental changes while maintaining stable, high-quality visuals throughout.',

        // 如何使用部分
        howToUseTitle: 'How to Use Wan 2.6 on 微鲤AI',
        step1Title: 'Choose a Model',
        step1Description: 'Select the Wan 2.6 model in the AI Video tool',
        step2Title: 'Enter Your Content',
        step2Description:
            'Describe the scene you want in the text box, or upload a reference image/video to enable “Image to Video” or “Performance & Motion Re-enactment”.',
        step3Title: 'Generate the Video',
        step3Description:
            'Set parameters (e.g., 16:9 aspect ratio, 15-second duration), click “Generate”, then wait a moment to preview and download your video with sound.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube Videos About the Wan 2.6 Video Model',

        // X Posts 部分
        xPostsTitle: 'Trending X Posts About the Wan 2.6 AI Video Model',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Other Models',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Wan 2.6?',
        faq1Answer:
            'Wan 2.6 is Alibaba Cloud’s latest AI video generation model, featuring cinematic-quality visuals, native audio-visual sync generation, and intelligent multi-shot storytelling.',
        faq2Question: 'What makes Wan 2.6 special?',
        faq2Answer:
            'The standout feature is “Native Audio-Visual Sync”. It not only generates the video, but also produces matching ambient sound and voices at the same time—eliminating tedious post-dubbing. It also delivers excellent multi-shot consistency.',
        faq3Question: 'Is Wan 2.6 free to use on 微鲤AI?',
        faq3Answer:
            '微鲤AI provides free credits for registered users to try Wan 2.6’s basic features. Generating HD, longer (15-second) videos may consume more credits or require upgrading to Pro.',
        faq4Question: 'How long are the generated videos?',
        faq4Answer:
            'It currently supports 5-second, 10-second, and up to 15-second clips. With the multi-shot feature, a single 15-second generation can include rich story beats.',
        faq5Question: 'What input modes does it support?',
        faq5Answer:
            'It supports “Text-to-Video”, “Image-to-Video”, and “Video-to-Video” (performance re-enactment), covering end-to-end creation from ideas to assets.',
        faq6Question: 'What’s the difference between Wan 2.6 and Wan 2.5?',
        faq6Answer:
            'Wan 2.6 is a fully upgraded commercial-grade (API) version: resolution increases from 720p to 1080p, audio generation is added, and motion smoothness and prompt following are significantly improved.',

        // CTA 部分
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Try Wan 2.6 now and turn your ideas into amazing videos',
        ctaButton: 'Try Wan 2.6 Now',
        ctaDisclaimer: 'No credit card required — sign up to start',

        // 视频播放相关
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadingError: 'Failed to load video',
        videoReload: 'Reload',
    },
    ja: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 動画生成 - 次世代マルチモーダルAI動画制作プラットフォーム',
        pageDescription:
            'Wan 2.6 のフラッグシップ級マルチモーダル AI 動画生成モデルを体験。映画品質の 1080p に対応し、Native Audio-Visual Sync（音声・映像のネイティブ同期）により、映像と一致する効果音や音声を同時に生成できます。微鲤AI で無料体験。',
        pageKeywords:
            'Wan 2.6, AI動画生成, マルチモーダルAI動画モデル, ネイティブ音声・映像同期, 映画品質1080p, ストーリーボード, 無料AI動画, 微鲤AI, 動画制作',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 フラッグシップ級マルチモーダル AI 動画生成モデル',
        short_title: 'マルチモーダルAI動画モデル',
        generatorDescription:
            'Wan 2.6 は、Alibaba Cloud の通義万相（Wanx）チームが最新リリースしたフラッグシップ級マルチモーダル AI 動画生成モデルです。Wan シリーズの大幅アップグレードとして、映画品質の 1080p 出力に対応するだけでなく、Native Audio-Visual Sync（音声・映像のネイティブ同期）という大きな突破を実現し、映像と一致する効果音や音声を一括生成できます。長尺ストーリーテリングの課題解決を目的に設計され、最大 15 秒の一貫したマルチショット生成を可能にする「インテリジェント分鏡」機能を搭載。“脚本から完成映像へ”を最短距離で実現する究極ツールです。微鲤AI で Wan 2.6 を無料で体験し、「音も映像も」AI で創る新時代を体感してください。',
        generatorDescriptionHighlight1:
            'Wan 2.6 は 微鲤AI の動画生成器に統合され、リアルな動画を生成できます',
        generatorDescriptionText2: '。こちらをクリックして',
        generatorDescriptionHighlight2: 'Wan 2.6 を無料で試す',
        generatorDescriptionEnd: '！',

        // 标签页
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 の主要機能',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'ネイティブ音声・映像同期生成',
        nativeAudioIntegrationDescription:
            'Wan 2.6 は視覚と聴覚の境界を打ち破り、映像生成と同時に、内容に合わせた高精度な同期音（足音・雨音など）や、キャラクターの口パクに合う台詞音声まで自動生成。後付けの吹き替えなしで、完成度の高い視聴覚素材を得られます。',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'インテリジェントなマルチショット物語生成',
        enhancedDynamicEffectsDescription:
            '強力な意味理解により、複雑で長いプロンプトを複数のショット（例：ワイド→クローズアップ）に自動分解し、キャラクターやシーンの光・影を高い一貫性で維持。1 回の生成で小さな物語を完結させられます。',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: '演技・動きの再現',
        preciseCameraControlDescription:
            '「動画から動画（video-to-video）」で実写の演技動画を参照としてアップロードすると、Wan 2.6 は動きの振れ幅や表情、さらにはカメラワークのリズムまでを、新しく生成する仮想キャラクター（アニメや 3D など）に高精度で移植し、“AI モーションキャプチャ”を実現します。',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: '最長 15 秒の一貫した長尺生成',
        enhancedVisualRealismDescription:
            '最大 15 秒の 1080p/24fps 高精細動画を生成可能。従来モデルの短尺クリップと比べ、複雑な動作や環境変化を表現する余裕が増え、全編を通して画質の破綻を抑えながら安定したクオリティを維持します。',

        // 如何使用部分
        howToUseTitle: '微鲤AI で Wan 2.6 を使う方法',
        step1Title: 'モデルを選択',
        step1Description: 'AI 動画ツールで Wan 2.6 モデルを選択します',
        step2Title: '内容を入力',
        step2Description:
            'テキスト欄に作りたい映像を説明するか、参照画像/動画をアップロードして「画像から動画」または「演技・動きの再現」を有効にします。',
        step3Title: '動画を生成',
        step3Description:
            'パラメータ（例：16:9 比率、15 秒）を設定し、「生成」をクリック。少し待つだけでプレビューとダウンロードができます。',

        // YouTube 视频部分
        youtubeTitle: 'Wan 2.6 動画モデルに関する YouTube 動画',

        // X Posts 部分
        xPostsTitle: 'Wan 2.6 AI 動画モデルに関する人気の X 投稿',

        // 探索其他模型部分
        exploreModelsTitle: '他のモデルを探す',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI 動画生成',
        sora2Title: 'OpenAI Sora-2 AI 動画生成',

        // FAQ 部分
        faqTitle: 'よくある質問',
        faq1Question: 'Wan 2.6 とは？',
        faq1Answer:
            'Wan 2.6 は Alibaba Cloud が提供する最新世代の AI 動画生成モデルで、映画品質の画質、ネイティブ音声・映像同期生成、インテリジェントなマルチショット物語生成などの革新的な機能を備えています。',
        faq2Question: 'Wan 2.6 の最大の特徴は？',
        faq2Answer:
            '最大の特徴は「ネイティブ音声・映像同期」です。動画を生成するだけでなく、一致する環境音や音声も同時に生成できるため、後工程の吹き替えの手間を省けます。さらに、マルチショットの一貫性も非常に優れています。',
        faq3Question: '微鲤AI で Wan 2.6 は無料で使えますか？',
        faq3Answer:
            '微鲤AI では登録ユーザーに無料クレジットを提供しており、Wan 2.6 の基本機能を体験できます。高画質・長尺（15 秒）動画の生成は、より多くのクレジット消費や Pro へのアップグレードが必要になる場合があります。',
        faq4Question: '生成できる動画の長さは？',
        faq4Answer:
            '現在は 5 秒、10 秒、最長 15 秒の動画クリップを生成できます。マルチショット機能により、1 回の 15 秒生成でも豊かな展開を盛り込めます。',
        faq5Question: 'どんな入力方式に対応していますか？',
        faq5Answer:
            '「テキストから動画（Text-to-Video）」「画像から動画（Image-to-Video）」「動画から動画（Video-to-Video／演技・動きの再現）」に対応し、アイデアから素材まで幅広い制作ニーズを満たします。',
        faq6Question: 'Wan 2.6 と Wan 2.5 の違いは？',
        faq6Answer:
            'Wan 2.6 は商用グレード（API）の全面アップグレード版で、解像度が 720p から 1080p に向上し、音声生成が追加され、動きの滑らかさと指示追従性が大幅に改善されています。',

        // CTA 部分
        ctaTitle: '制作を始めますか？',
        ctaDescription:
            '今すぐ Wan 2.6 を体験して、アイデアを素敵な動画に変えましょう',
        ctaButton: 'Wan 2.6 を今すぐ体験',
        ctaDisclaimer: 'クレジットカード不要、登録だけですぐ利用可能',

        // 视频播放相关
        videoNotSupported: 'お使いのブラウザは動画再生に対応していません',
        videoLoadingError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
    },
    ko: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 비디오 생성기 - 차세대 멀티모달 AI 영상 제작 플랫폼',
        pageDescription:
            '플래그십 멀티모달 AI 비디오 생성 모델 Wan 2.6을 경험해 보세요. 영화급 1080p 해상도는 물론 Native Audio-Visual Sync(원생 오디오-비주얼 동기화)로 영상과 어울리는 효과음·음성까지 한 번에 생성합니다. WeryAI에서 무료로 사용해 보세요.',
        pageKeywords:
            'Wan 2.6, AI 비디오 생성기, 멀티모달 AI 비디오 모델, 원생 오디오-비주얼 동기화, 영화급 1080p, 스마트 스토리보드, 무료 AI 영상, 微鲤AI, 영상 제작',

        // 生成器部分
        generatorTitle: 'Wan 2.6 플래그십 멀티모달 AI 비디오 생성 모델',
        short_title: '멀티모달 AI 비디오 모델',
        generatorDescription:
            'Wan 2.6은 Alibaba Cloud 통의만상(Tongyi Wanxiang, Wanx) 팀이 최신 공개한 플래그십 멀티모달 AI 비디오 생성 모델입니다. Wan 시리즈의 대형 업그레이드로, 영화급 1080p 출력뿐 아니라 Native Audio-Visual Sync(원생 오디오-비주얼 동기화)라는 돌파를 통해 영상과 매칭되는 효과음·음성을 한 번에 생성할 수 있습니다. 장편 스토리텔링의 난제를 해결하기 위해 설계되었으며, 최대 15초까지 이어지는 다중 샷(멀티 카메라) 생성이 가능한 ‘스마트 분할 컷(스토리보드)’ 기능으로 “대본에서 완성본까지”를 빠르게 돕습니다. WeryAI에서 Wan 2.6을 무료로 체험하고, ‘소리와 화면이 함께’ 만들어지는 AI 창작의 새 시대를 만나보세요.',
        generatorDescriptionHighlight1:
            'Wan 2.6 모델이 微鲤AI 비디오 생성기에 통합되어 사실적인 영상을 만들 수 있습니다',
        generatorDescriptionText2: '. 여기를 클릭하여',
        generatorDescriptionHighlight2: 'Wan 2.6 무료 체험',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: '이미지 → 비디오',
        tabTextToVideo: '텍스트 → 비디오',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 핵심 기능',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: '원생 오디오-비주얼 동기화 생성',
        nativeAudioIntegrationDescription:
            'Wan 2.6은 시각과 청각의 경계를 허물어, 영상 생성과 동시에 콘텐츠에 맞춘 정밀 동기화 음향(예: 발소리, 빗소리)과 캐릭터 대사 립싱크까지 자동으로 생성합니다. 후반 더빙 없이도 완성도 높은 시청각 소재를 얻을 수 있습니다.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: '지능형 멀티샷 스토리텔링',
        enhancedDynamicEffectsDescription:
            '강력한 의미 이해 능력으로 복잡한 장문 프롬프트를 여러 컷(예: 와이드 → 클로즈업)으로 자동 분해하고, 컷 간 캐릭터·장면·조명 일관성을 높게 유지해 한 번의 생성으로 작은 이야기를 완성할 수 있습니다.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: '연기/모션 재현',
        preciseCameraControlDescription:
            '“비디오 → 비디오” 기능으로 실제 연기 영상을 레퍼런스로 업로드하면, Wan 2.6이 동작 범위·표정·카메라 워크 리듬까지 새로 생성되는 가상 캐릭터(애니메이션/3D 등)에 정밀하게 옮겨 ‘AI 모션 캡처’를 구현합니다.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: '최대 15초 장면 일관 생성',
        enhancedVisualRealismDescription:
            '최대 15초의 1080p/24fps 고화질 영상을 생성합니다. 기존 모델의 짧은 클립 대비, 복잡한 동작과 환경 변화를 표현할 시간이 더 넉넉하며, 전 구간에서 안정적인 화질을 유지합니다.',

        // 如何使用部分
        howToUseTitle: 'WeryAI에서 Wan 2.6 사용하는 방법',
        step1Title: '모델 선택',
        step1Description: 'AI 비디오 도구에서 Wan 2.6 모델을 선택하세요',
        step2Title: '내용 입력',
        step2Description:
            '텍스트 박스에 원하는 장면을 설명하거나, 참고 이미지/영상을 업로드해 “이미지 → 비디오” 또는 “연기/모션 재현” 기능을 사용하세요.',
        step3Title: '비디오 생성',
        step3Description:
            '파라미터(예: 16:9 비율, 15초 길이)를 설정한 뒤 “생성”을 클릭하면 잠시 후 미리보기 및 다운로드가 가능합니다.',

        // YouTube 视频部分
        youtubeTitle: 'Wan 2.6 비디오 모델 관련 YouTube 영상',

        // X Posts 部分
        xPostsTitle: 'Wan 2.6 AI 비디오 모델 인기 X 게시물',

        // 探索其他模型部分
        exploreModelsTitle: '다른 모델 둘러보기',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI 비디오 생성기',
        sora2Title: 'OpenAI Sora-2 AI 비디오 생성기',

        // FAQ 部分
        faqTitle: '자주 묻는 질문',
        faq1Question: 'Wan 2.6이란?',
        faq1Answer:
            'Wan 2.6은 Alibaba Cloud가 출시한 최신 AI 비디오 생성 모델로, 영화급 화질, 원생 오디오-비주얼 동기화 생성, 지능형 멀티샷 스토리텔링 등 혁신적인 기능을 갖추고 있습니다.',
        faq2Question: 'Wan 2.6의 가장 큰 특징은 무엇인가요?',
        faq2Answer:
            '가장 큰 특징은 “원생 오디오-비주얼 동기화”입니다. 영상뿐 아니라 매칭되는 환경음과 음성까지 동시에 생성해 후반 더빙의 번거로움을 줄여줍니다. 또한 멀티샷 일관성도 매우 뛰어납니다.',
        faq3Question: 'WeryAI에서 Wan 2.6은 무료인가요?',
        faq3Answer:
            'WeryAI는 가입 사용자에게 무료 크레딧을 제공하며, Wan 2.6의 기본 기능을 체험할 수 있습니다. 고화질·장시간(15초) 영상 생성은 더 많은 크레딧을 소모하거나 Pro 업그레이드가 필요할 수 있습니다.',
        faq4Question: '생성되는 영상 길이는 얼마나 되나요?',
        faq4Answer:
            '현재 5초, 10초, 최대 15초 길이의 클립을 지원합니다. 멀티샷 기능을 활용하면 한 번의 15초 생성에서도 풍부한 전개를 담을 수 있습니다.',
        faq5Question: '어떤 입력 방식을 지원하나요?',
        faq5Answer:
            '“텍스트 → 비디오”(Text-to-Video), “이미지 → 비디오”(Image-to-Video), “비디오 → 비디오”(Video-to-Video/연기·모션 재현)를 지원해 아이디어부터 소재까지 폭넓게 제작할 수 있습니다.',
        faq6Question: 'Wan 2.6과 Wan 2.5의 차이는 무엇인가요?',
        faq6Answer:
            'Wan 2.6은 상용 등급(API)으로 전면 업그레이드된 버전으로, 해상도가 720p에서 1080p로 향상되고 오디오 생성이 추가되었으며, 동작의 부드러움과 지시(프롬프트) 준수 성능이 크게 개선되었습니다.',

        // CTA 部分
        ctaTitle: '창작을 시작할 준비가 되셨나요?',
        ctaDescription:
            '지금 Wan 2.6을 체험하고 아이디어를 멋진 영상으로 바꿔보세요',
        ctaButton: 'Wan 2.6 지금 체험하기',
        ctaDisclaimer: '신용카드 불필요, 가입만 하면 바로 사용 가능',

        // 视频播放相关
        videoNotSupported: '브라우저가 비디오 재생을 지원하지 않습니다',
        videoLoadingError: '비디오 로딩 실패',
        videoReload: '다시 로드',
    },
    tw: {

        // 页面标题和描述
        pageTitle: 'Wan 2.6 视频生成器 - 新一代多模态AI视频创作平台',
        pageDescription:
            '体验Wan 2.6旗舰级多模态 AI 视频生成模型，不仅支持生成电影级 1080p 分辨率的视频，更实现了 原生音视频同步（Native Audio-Visual Sync）的突破，能够一次性生成画面与匹配的音效、人声。在WeryAI平台免费试用。',
        pageKeywords:
            'Wan 2.6, AI视频生成器,多模态 AI 视频生成模型,原生音视频同步, 电影级 1080p 分辨率, 智能分镜功能, 免费AI视频, 微鲤AI, 视频制作',

        // 生成器部分
        generatorTitle: 'Wan 2.6 旗舰级多模态 AI 视频生成模型',
        short_title: '多模态AI视频模型',
        generatorDescription:
            'Wan 2.6 是阿里云通义万相（Wanx）团队最新发布的旗舰级多模态 AI 视频生成模型。作为 Wan 系列的重大升级版本，它不仅支持生成电影级 1080p 分辨率的视频，更实现了 原生音视频同步（Native Audio-Visual Sync）的突破，能够一次性生成画面与匹配的音效、人声。Wan 2.6 专为解决长视频叙事难题而生，其独有的智能分镜功能支持长达 15 秒的连贯多镜头创作，是创作者实现“从剧本到成片”的终极工具。快来 微鲤AI 免费体验 Wan 2.6，感受“有声有色”的 AI 创作新纪元！',
        generatorDescriptionHighlight1:
            'Wan 2.6 模型现已集成到 微鲤AI 视频生成器中，可生成逼真的视频',
        generatorDescriptionText2: '。点击此处',
        generatorDescriptionHighlight2: '免费试用 Wan 2.6',
        generatorDescriptionEnd: '！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 核心功能特性',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: '原生音视频同步生成',
        nativeAudioIntegrationDescription:
            'Wan 2.6 打破了视觉与听觉的界限，在生成视频画面的同时，能够根据内容自动生成精准同步的音效（如脚步声、雨声）甚至角色对白口型，无需后期配音即可获得完整的视听素材。',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: '智能多镜头叙事',
        enhancedDynamicEffectsDescription:
            '模型具备极强的语义理解能力，能自动将一段复杂的长提示词拆解为多个分镜（如全景接特写），并确保角色形象、场景光影在不同镜头间保持高度一致，单次生成即可讲述一个完整的小故事。',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: '角色表演复刻',
        preciseCameraControlDescription:
            '通过“视频生视频”功能，用户可以上传一段真人表演视频作为参考，Wan 2.6 能将原视频中的动作幅度、面部表情甚至运镜节奏，精准迁移到新生成的虚拟角色（如动漫人物或3D模型）身上，实现“AI 动作捕捉”。',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: '15 秒长视频连贯生成',
        enhancedVisualRealismDescription:
            '支持生成长达 15 秒的 1080p/24fps 高清视频，相比传统模型的短片段，Wan 2.6 提供了更充裕的时间来展现复杂的动作逻辑和环境变化，且全程保持画质无崩坏。',

        // 如何使用部分
        howToUseTitle: '如何在 微鲤AI 上使用 Wan 2.6',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Wan 2.6 模型',
        step2Title: '输入内容',
        step2Description:
            '在文本框中描述您想要的画面，或上传参考图片/视频以启用“图生视频”或“角色复刻”功能。',
        step3Title: '生成视频',
        step3Description:
            '设置参数（如 16:9 比例、15秒时长），点击“生成”按钮，稍等片刻即可预览并下载您的有声大片。',

        // YouTube 视频部分
        youtubeTitle: '关于 Wan 2.6 视频模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Wan 2.6 AI 视频模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI 视频生成器',
        sora2Title: 'OpenAI Sora-2 AI 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: 'Wan 2.6是什么?',
        faq1Answer:
            'Wan 2.6 是阿里云推出的最新一代 AI 视频生成模型，具备电影级画质、原生音画同步生成以及智能多镜头叙事等突破性功能。',
        faq2Question: 'Wan 2.6 最大的特色是什么？',
        faq2Answer:
            '最大的特色是“原生音视频同步”，它不仅生成视频，还能同时生成匹配的环境音和人声，省去了后期配音的繁琐步骤。此外，它的多镜头一致性也非常出色。',
        faq3Question: '在 微鲤AI 上使用 Wan 2.6 是免费的吗？?',
        faq3Answer:
            '微鲤AI 为注册用户提供免费的积分额度，可用于体验 Wan 2.6 的基础功能。生成高清、长时长（15秒）视频可能需要消耗更多积分或升级为 Pro 会员。',
        faq4Question: 'Wan 2.6 生成的视频有多长？',
        faq4Answer:
            '目前支持生成 5秒、10秒 和最长 15秒 的视频片段。通过多镜头功能，单次生成的 15 秒视频可以包含丰富的情节转折。',
        faq5Question: '它支持哪些输入方式？',
        faq5Answer:
            '支持“文生视频”（Text-to-Video）、“图生视频”（Image-to-Video）以及“视频生视频”（Video-to-Video/角色复刻），满足从灵感到素材的全方位创作需求。',
        faq6Question: 'Wan 2.6 和 Wan 2.5 有什么区别？',
        faq6Answer:
            'Wan 2.6 是全面升级的商业级版本（API），画质从 720p 提升至 1080p，增加了音频生成能力，并大幅优化了动作的流畅度和指令遵循度。',
        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Wan 2.6，将您的创意转化为精彩视频',
        ctaButton: '立即体验 Wan 2.6',
        ctaDisclaimer: '无须信用卡，注册即可使用',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoReload: '重新加载',
    },
    pl: {

        // 页面标题和描述
        pageTitle:
            'Wan 2.6 Video Generator - Next-Gen Multimodal AI Video Creation Platform',
        pageDescription:
            'Try Wan 2.6, a flagship multimodal AI video generation model. It delivers cinematic 1080p video and a breakthrough in Native Audio-Visual Sync—generating visuals together with matching sound effects and voices in one go. Free to try on 微鲤AI.',
        pageKeywords:
            'Wan 2.6, AI video generator, multimodal AI video model, native audio-visual sync, cinematic 1080p, intelligent storyboarding, free AI video, 微鲤AI, video creation',

        // 生成器部分
        generatorTitle: 'Wan 2.6 Flagship Multimodal AI Video Generation Model',
        short_title: 'Multimodal AI Video Model',
        generatorDescription:
            'Wan 2.6 is the latest flagship multimodal AI video generation model released by Alibaba Cloud’s Tongyi Wanxiang (Wanx) team. As a major upgrade in the Wan series, it not only supports cinematic 1080p output but also achieves a breakthrough in Native Audio-Visual Sync—generating visuals along with matched sound effects and voices in a single pass. Built to tackle long-form storytelling, Wan 2.6 features intelligent multi-shot storyboarding that enables up to 15 seconds of coherent, multi-camera creation, helping creators go from script to final cut. Try Wan 2.6 for free on 微鲤AI and step into a new era of “video with sound, made by AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 is now integrated into the 微鲤AI video generator to create realistic videos',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'try Wan 2.6 for free',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 Key Features',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Native Audio-Visual Sync Generation',
        nativeAudioIntegrationDescription:
            'Wan 2.6 breaks the boundary between sight and sound—while generating the video, it can automatically create precisely synchronized audio (e.g., footsteps, rain) and even character dialogue lip-sync, delivering complete audiovisual assets without post-dubbing.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Intelligent Multi-Shot Storytelling',
        enhancedDynamicEffectsDescription:
            'With strong semantic understanding, the model can decompose a complex long prompt into multiple shots (e.g., wide to close-up) and keep character identity, scenes, and lighting highly consistent across shots—telling a complete mini story in a single generation.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performance & Motion Re-enactment',
        preciseCameraControlDescription:
            'Using “video-to-video”, you can upload a real performance clip as reference. Wan 2.6 can accurately transfer the motion range, facial expressions, and even camera rhythm to a newly generated virtual character (e.g., anime or 3D), enabling “AI motion capture”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Coherent 15-Second Long Video Generation',
        enhancedVisualRealismDescription:
            'Generate up to 15 seconds of 1080p/24fps HD video. Compared with short clips from traditional models, Wan 2.6 gives more time to portray complex actions and environmental changes while maintaining stable, high-quality visuals throughout.',

        // 如何使用部分
        howToUseTitle: 'How to Use Wan 2.6 on 微鲤AI',
        step1Title: 'Choose a Model',
        step1Description: 'Select the Wan 2.6 model in the AI Video tool',
        step2Title: 'Enter Your Content',
        step2Description:
            'Describe the scene you want in the text box, or upload a reference image/video to enable “Image to Video” or “Performance & Motion Re-enactment”.',
        step3Title: 'Generate the Video',
        step3Description:
            'Set parameters (e.g., 16:9 aspect ratio, 15-second duration), click “Generate”, then wait a moment to preview and download your video with sound.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube Videos About the Wan 2.6 Video Model',

        // X Posts 部分
        xPostsTitle: 'Trending X Posts About the Wan 2.6 AI Video Model',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Other Models',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Wan 2.6?',
        faq1Answer:
            'Wan 2.6 is Alibaba Cloud’s latest AI video generation model, featuring cinematic-quality visuals, native audio-visual sync generation, and intelligent multi-shot storytelling.',
        faq2Question: 'What makes Wan 2.6 special?',
        faq2Answer:
            'The standout feature is “Native Audio-Visual Sync”. It not only generates the video, but also produces matching ambient sound and voices at the same time—eliminating tedious post-dubbing. It also delivers excellent multi-shot consistency.',
        faq3Question: 'Is Wan 2.6 free to use on 微鲤AI?',
        faq3Answer:
            '微鲤AI provides free credits for registered users to try Wan 2.6’s basic features. Generating HD, longer (15-second) videos may consume more credits or require upgrading to Pro.',
        faq4Question: 'How long are the generated videos?',
        faq4Answer:
            'It currently supports 5-second, 10-second, and up to 15-second clips. With the multi-shot feature, a single 15-second generation can include rich story beats.',
        faq5Question: 'What input modes does it support?',
        faq5Answer:
            'It supports “Text-to-Video”, “Image-to-Video”, and “Video-to-Video” (performance re-enactment), covering end-to-end creation from ideas to assets.',
        faq6Question: 'What’s the difference between Wan 2.6 and Wan 2.5?',
        faq6Answer:
            'Wan 2.6 is a fully upgraded commercial-grade (API) version: resolution increases from 720p to 1080p, audio generation is added, and motion smoothness and prompt following are significantly improved.',

        // CTA 部分
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Try Wan 2.6 now and turn your ideas into amazing videos',
        ctaButton: 'Try Wan 2.6 Now',
        ctaDisclaimer: 'No credit card required — sign up to start',

        // 视频播放相关
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadingError: 'Failed to load video',
        videoReload: 'Reload',
    },
    es: {
        // 页面标题和描述
        pageTitle:
            'Generador de video Wan 2.6 - Plataforma de creación de video con IA multimodal de nueva generación',
        pageDescription:
            'Descubre Wan 2.6, el modelo multimodal insignia de generación de video con IA. Ofrece video 1080p con calidad cinematográfica y un avance en Native Audio-Visual Sync: genera imagen y sonido (efectos y voz) sincronizados en una sola pasada. Pruébalo gratis en 微鲤AI.',
        pageKeywords:
            'Wan 2.6, generador de video con IA, modelo de video IA multimodal, sincronización nativa audio-visual, 1080p cinematográfico, guion gráfico inteligente, video IA gratis, 微鲤AI, creación de video',

        // 生成器部分
        generatorTitle:
            'Wan 2.6: modelo insignia multimodal de generación de video con IA',
        short_title: 'Modelo de video de IA multimodal',
        generatorDescription:
            'Wan 2.6 es el modelo multimodal insignia más reciente publicado por el equipo de Tongyi Wanxiang (Wanx) de Alibaba Cloud. Como una gran actualización de la serie Wan, no solo admite salida 1080p con calidad cinematográfica, sino que también logra un avance en Native Audio-Visual Sync: genera el video junto con efectos de sonido y voces que encajan en una sola ejecución. Diseñado para resolver el desafío de la narrativa en videos largos, Wan 2.6 incluye un sistema de guion gráfico inteligente de múltiples tomas que permite hasta 15 segundos de creación coherente con varios planos, ayudando a los creadores a pasar “del guion al corte final”. Pruébalo gratis en 微鲤AI y vive una nueva era de creación con IA, con imagen y sonido.',
        generatorDescriptionHighlight1:
            'Wan 2.6 ya está integrado en el generador de video de 微鲤AI para crear videos realistas',
        generatorDescriptionText2: '. Haz clic aquí para',
        generatorDescriptionHighlight2: 'probar Wan 2.6 gratis',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Imagen a video',
        tabTextToVideo: 'Texto a video',

        // 核心功能部分
        coreFeaturesTitle: 'Funciones clave de Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle:
            'Generación con sincronización nativa audio‑visual',
        nativeAudioIntegrationDescription:
            'Wan 2.6 rompe la barrera entre lo visual y lo auditivo: mientras genera el video, puede crear automáticamente audio sincronizado con precisión (p. ej., pasos, lluvia) e incluso diálogo con lip‑sync, entregando recursos audiovisuales completos sin doblaje posterior.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Narrativa inteligente de múltiples tomas',
        enhancedDynamicEffectsDescription:
            'Con una gran comprensión semántica, el modelo puede descomponer un prompt largo y complejo en varias tomas (p. ej., plano general a primer plano) y mantener alta consistencia de personajes, escena e iluminación entre tomas, contando una historia completa en una sola generación.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Recreación de actuación y movimiento',
        preciseCameraControlDescription:
            'Con “video a video”, puedes subir un clip de actuación real como referencia. Wan 2.6 puede transferir con precisión el rango de movimiento, expresiones faciales e incluso el ritmo de cámara a un personaje virtual recién generado (p. ej., anime o 3D), logrando “captura de movimiento con IA”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle:
            'Generación coherente de video largo de 15 segundos',
        enhancedVisualRealismDescription:
            'Genera hasta 15 segundos de video HD 1080p/24fps. Frente a los clips cortos de modelos tradicionales, Wan 2.6 ofrece más tiempo para mostrar acciones complejas y cambios del entorno, manteniendo una calidad estable de principio a fin.',

        // 如何使用部分
        howToUseTitle: 'Cómo usar Wan 2.6 en 微鲤AI',
        step1Title: 'Elige el modelo',
        step1Description:
            'Selecciona el modelo Wan 2.6 en la herramienta de video con IA',
        step2Title: 'Introduce el contenido',
        step2Description:
            'Describe la escena en el cuadro de texto o sube una imagen/video de referencia para activar “Imagen a video” o “Recreación de actuación y movimiento”.',
        step3Title: 'Genera el video',
        step3Description:
            'Configura parámetros (p. ej., relación 16:9 y duración de 15 s), haz clic en “Generar” y en unos momentos podrás previsualizar y descargar tu video con sonido.',

        // YouTube 视频部分
        youtubeTitle: 'Videos de YouTube sobre el modelo de video Wan 2.6',

        // X Posts 部分
        xPostsTitle:
            'Publicaciones populares en X sobre el modelo de video con IA Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'Explora otros modelos',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Generador de video con IA Google Veo 3.1',
        sora2Title: 'Generador de video con IA OpenAI Sora-2',

        // FAQ 部分
        faqTitle: 'Preguntas frecuentes',
        faq1Question: '¿Qué es Wan 2.6?',
        faq1Answer:
            'Wan 2.6 es el modelo más reciente de generación de video con IA de Alibaba Cloud, con calidad cinematográfica, sincronización nativa audio‑visual y narrativa inteligente de múltiples tomas.',
        faq2Question: '¿Cuál es la característica más destacada de Wan 2.6?',
        faq2Answer:
            'La característica estrella es la “sincronización nativa audio‑visual”. No solo genera el video, sino también el sonido ambiente y las voces a juego al mismo tiempo, evitando el doblaje posterior. Además, su consistencia entre tomas es excelente.',
        faq3Question: '¿Es gratis usar Wan 2.6 en 微鲤AI?',
        faq3Answer:
            '微鲤AI ofrece créditos gratuitos a los usuarios registrados para probar las funciones básicas de Wan 2.6. Generar videos en HD y de mayor duración (15 s) puede consumir más créditos o requerir la suscripción Pro.',
        faq4Question: '¿Cuánto duran los videos generados?',
        faq4Answer:
            'Actualmente admite clips de 5 s, 10 s y hasta 15 s. Con la función multi‑toma, una sola generación de 15 s puede incluir giros narrativos ricos.',
        faq5Question: '¿Qué modos de entrada admite?',
        faq5Answer:
            'Admite “Texto a video” (Text-to-Video), “Imagen a video” (Image-to-Video) y “Video a video” (Video-to-Video/recreación), cubriendo la creación desde la idea hasta el material.',
        faq6Question: '¿En qué se diferencia Wan 2.6 de Wan 2.5?',
        faq6Answer:
            'Wan 2.6 es una versión comercial (API) totalmente mejorada: la resolución pasa de 720p a 1080p, incorpora generación de audio y mejora notablemente la fluidez del movimiento y el seguimiento de instrucciones.',

        // CTA 部分
        ctaTitle: '¿Listo para empezar a crear?',
        ctaDescription:
            'Prueba Wan 2.6 ahora y convierte tus ideas en videos increíbles',
        ctaButton: 'Probar Wan 2.6 ahora',
        ctaDisclaimer: 'Sin tarjeta de crédito: regístrate y empieza',

        // 视频播放相关
        videoNotSupported: 'Tu navegador no admite la reproducción de video',
        videoLoadingError: 'No se pudo cargar el video',
        videoReload: 'Recargar',
    },
    fr: {
        // 页面标题和描述
        pageTitle:
            'Générateur de vidéo Wan 2.6 - Plateforme de création vidéo IA multimodale nouvelle génération',
        pageDescription:
            'Découvrez Wan 2.6, le modèle multimodal IA phare de génération vidéo. Il produit des vidéos 1080p de qualité cinéma et franchit un cap avec le Native Audio-Visual Sync : image et audio (effets, voix) synchronisés générés en une seule fois. Essai gratuit sur 微鲤AI.',
        pageKeywords:
            'Wan 2.6, générateur de vidéo IA, modèle vidéo IA multimodal, synchronisation native audio-visuelle, 1080p cinéma, storyboard intelligent, vidéo IA gratuite, 微鲤AI, création vidéo',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 - Modèle multimodal IA phare de génération vidéo',
        short_title: 'Modèle vidéo IA multimodal',
        generatorDescription:
            'Wan 2.6 est le tout dernier modèle multimodal IA phare publié par l’équipe Tongyi Wanxiang (Wanx) d’Alibaba Cloud. En tant que mise à niveau majeure de la série Wan, il prend en charge une sortie 1080p de qualité cinéma et réalise une avancée avec le Native Audio-Visual Sync : il génère l’image en même temps que des effets sonores et des voix parfaitement assortis, en une seule passe. Conçu pour résoudre les défis de narration en vidéo longue, Wan 2.6 intègre un storyboard multi‑plans intelligent permettant jusqu’à 15 secondes de création cohérente multi‑caméra, pour aider les créateurs à passer “du script au montage final”. Essayez Wan 2.6 gratuitement sur 微鲤AI et entrez dans une nouvelle ère de création IA, avec image et son.',
        generatorDescriptionHighlight1:
            'Wan 2.6 est désormais intégré au générateur vidéo 微鲤AI pour créer des vidéos réalistes',
        generatorDescriptionText2: '. Cliquez ici pour',
        generatorDescriptionHighlight2: 'essayer Wan 2.6 gratuitement',
        generatorDescriptionEnd: ' !',

        // 标签页
        tabImageToVideo: 'Image → Vidéo',
        tabTextToVideo: 'Texte → Vidéo',

        // 核心功能部分
        coreFeaturesTitle: 'Fonctionnalités clés de Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle:
            'Génération avec synchronisation native audio‑visuelle',
        nativeAudioIntegrationDescription:
            'Wan 2.6 dépasse la frontière entre le visuel et l’audio : lors de la génération de la vidéo, il peut créer automatiquement un son synchronisé avec précision (ex. pas, pluie) et même des dialogues avec lip‑sync, pour fournir des assets audiovisuels complets sans doublage en post‑production.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Narration multi‑plans intelligente',
        enhancedDynamicEffectsDescription:
            'Grâce à une compréhension sémantique puissante, le modèle peut décomposer un long prompt complexe en plusieurs plans (ex. plan large puis gros plan) et maintenir une forte cohérence des personnages, des scènes et de l’éclairage d’un plan à l’autre, racontant une histoire complète en une seule génération.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle:
            'Reproduction d’interprétation et de mouvement',
        preciseCameraControlDescription:
            'Avec “vidéo vers vidéo”, vous pouvez importer une vidéo de performance réelle comme référence. Wan 2.6 transfère avec précision l’amplitude des mouvements, les expressions faciales et même le rythme de la caméra vers un personnage virtuel nouvellement généré (anime ou 3D), réalisant une “capture de mouvement IA”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle:
            'Génération longue cohérente jusqu’à 15 secondes',
        enhancedVisualRealismDescription:
            'Générez jusqu’à 15 secondes de vidéo HD en 1080p/24fps. Par rapport aux clips courts des modèles traditionnels, Wan 2.6 offre plus de temps pour illustrer des actions complexes et des changements d’environnement, tout en conservant une qualité stable du début à la fin.',

        // 如何使用部分
        howToUseTitle: 'Comment utiliser Wan 2.6 sur 微鲤AI',
        step1Title: 'Choisir le modèle',
        step1Description:
            'Dans l’outil de vidéo IA, sélectionnez le modèle Wan 2.6',
        step2Title: 'Saisir le contenu',
        step2Description:
            'Décrivez la scène dans la zone de texte ou importez une image/vidéo de référence pour activer “Image → Vidéo” ou la “Reproduction d’interprétation et de mouvement”.',
        step3Title: 'Générer la vidéo',
        step3Description:
            'Réglez les paramètres (ex. format 16:9, durée 15 s), cliquez sur “Générer”, puis prévisualisez et téléchargez votre vidéo avec son.',

        // YouTube 视频部分
        youtubeTitle: 'Vidéos YouTube à propos du modèle vidéo Wan 2.6',

        // X Posts 部分
        xPostsTitle: 'Posts X populaires à propos du modèle vidéo IA Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'Découvrir d’autres modèles',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Générateur vidéo IA Google Veo 3.1',
        sora2Title: 'Générateur vidéo IA OpenAI Sora-2',

        // FAQ 部分
        faqTitle: 'Questions fréquentes',
        faq1Question: 'Qu’est-ce que Wan 2.6 ?',
        faq1Answer:
            'Wan 2.6 est le dernier modèle de génération vidéo IA d’Alibaba Cloud, avec une qualité cinéma, une génération synchronisée audio‑visuelle native et une narration intelligente multi‑plans.',
        faq2Question: 'Quelle est la principale particularité de Wan 2.6 ?',
        faq2Answer:
            'La fonctionnalité phare est la “synchronisation native audio‑visuelle”. Elle génère non seulement la vidéo, mais aussi l’ambiance sonore et les voix assorties en même temps, évitant le doublage en post‑production. Sa cohérence multi‑plans est également excellente.',
        faq3Question: 'Wan 2.6 est-il gratuit sur 微鲤AI ?',
        faq3Answer:
            '微鲤AI offre des crédits gratuits aux utilisateurs inscrits pour tester les fonctionnalités de base de Wan 2.6. Générer des vidéos HD et longues (15 s) peut consommer davantage de crédits ou nécessiter un passage à Pro.',
        faq4Question: 'Quelle est la durée des vidéos générées ?',
        faq4Answer:
            'Le service prend en charge des clips de 5 s, 10 s et jusqu’à 15 s. Grâce au multi‑plans, une seule génération de 15 s peut contenir une narration riche.',
        faq5Question: 'Quels modes d’entrée sont pris en charge ?',
        faq5Answer:
            'Prise en charge de “Texte → Vidéo” (Text-to-Video), “Image → Vidéo” (Image-to-Video) et “Vidéo → Vidéo” (Video-to-Video/reproduction), pour créer de l’idée jusqu’aux assets.',
        faq6Question: 'Quelle différence entre Wan 2.6 et Wan 2.5 ?',
        faq6Answer:
            'Wan 2.6 est une version commerciale (API) entièrement améliorée : la résolution passe de 720p à 1080p, la génération audio est ajoutée et la fluidité des mouvements ainsi que le suivi des instructions sont grandement optimisés.',

        // CTA 部分
        ctaTitle: 'Prêt à créer ?',
        ctaDescription:
            'Essayez Wan 2.6 dès maintenant et transformez vos idées en superbes vidéos',
        ctaButton: 'Essayer Wan 2.6',
        ctaDisclaimer:
            'Aucune carte bancaire requise — inscrivez-vous pour commencer',

        // 视频播放相关
        videoNotSupported:
            'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadingError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
    },
    de: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 Videogenerator - Multimodale KI-Videoplattform der nächsten Generation',
        pageDescription:
            'Erlebe Wan 2.6, ein multimodales KI-Flaggschiff für Videogenerierung. Es liefert filmreife 1080p-Videos und einen Durchbruch bei Native Audio-Visual Sync: Bild und passender Ton (Effekte, Stimme) entstehen in einem Durchlauf. Kostenlos auf 微鲤AI testen.',
        pageKeywords:
            'Wan 2.6, KI Videogenerator, multimodales KI Videomodell, native Audio-Visual Sync, filmreife 1080p, intelligentes Storyboarding, kostenloses KI Video, 微鲤AI, Videoproduktion',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 - Multimodales KI-Flaggschiff für Videogenerierung',
        short_title: 'Multimodales KI-Videomodell',
        generatorDescription:
            'Wan 2.6 ist das neueste multimodale KI-Flaggschiff zur Videogenerierung, veröffentlicht vom Tongyi Wanxiang (Wanx) Team von Alibaba Cloud. Als großes Upgrade der Wan-Serie unterstützt es nicht nur filmreife 1080p-Ausgabe, sondern erreicht auch einen Durchbruch bei Native Audio-Visual Sync: Es erzeugt Bildmaterial zusammen mit passenden Soundeffekten und Stimmen in einem einzigen Durchlauf. Entwickelt für die Herausforderungen längerer Erzählformate, bietet Wan 2.6 intelligentes Multi‑Shot‑Storyboarding für bis zu 15 Sekunden kohärente, mehrkameraartige Erstellung – ideal, um “vom Skript zum finalen Schnitt” zu gelangen. Teste Wan 2.6 kostenlos auf 微鲤AI und erlebe eine neue Ära der KI‑Kreation – mit Bild und Ton.',
        generatorDescriptionHighlight1:
            'Wan 2.6 ist jetzt im 微鲤AI Videogenerator integriert und erstellt realistische Videos',
        generatorDescriptionText2: '. Klicke hier, um',
        generatorDescriptionHighlight2: 'Wan 2.6 kostenlos zu testen',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // 核心功能部分
        coreFeaturesTitle: 'Kernfunktionen von Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Native Audio-Visual Sync-Generierung',
        nativeAudioIntegrationDescription:
            'Wan 2.6 hebt die Grenze zwischen Sehen und Hören auf: Während das Video entsteht, erzeugt es automatisch präzise synchronisierten Ton (z. B. Schritte, Regen) und sogar Dialoge mit Lippen‑Sync – für vollständige audiovisuelle Assets ohne nachträgliches Dubbing.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Intelligentes Multi‑Shot‑Storytelling',
        enhancedDynamicEffectsDescription:
            'Dank starker semantischer Verständniskraft kann das Modell einen komplexen, langen Prompt in mehrere Shots (z. B. Weitwinkel zu Nahaufnahme) zerlegen und dabei Charaktere, Szenen sowie Lichtstimmung zwischen den Shots sehr konsistent halten – so entsteht in einem Durchlauf eine komplette Mini‑Story.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performance- & Bewegungsrekonstruktion',
        preciseCameraControlDescription:
            'Mit “Video‑zu‑Video” kannst du einen realen Performance‑Clip als Referenz hochladen. Wan 2.6 überträgt Bewegungsumfang, Mimik und sogar das Kamerarhythmusgefühl präzise auf eine neu generierte virtuelle Figur (z. B. Anime oder 3D) – das ermöglicht “KI‑Motion‑Capture”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle:
            'Kohärente 15‑Sekunden‑Langvideo‑Generierung',
        enhancedVisualRealismDescription:
            'Erzeuge bis zu 15 Sekunden 1080p/24fps‑HD‑Video. Im Vergleich zu kurzen Clips traditioneller Modelle bietet Wan 2.6 mehr Zeit für komplexe Aktionen und Umgebungswechsel – bei stabiler, hochwertiger Bildqualität über die gesamte Dauer.',

        // 如何使用部分
        howToUseTitle: 'So verwendest du Wan 2.6 auf 微鲤AI',
        step1Title: 'Modell auswählen',
        step1Description: 'Wähle im KI‑Video‑Tool das Modell Wan 2.6 aus',
        step2Title: 'Inhalt eingeben',
        step2Description:
            'Beschreibe die gewünschte Szene im Textfeld oder lade ein Referenzbild/-video hoch, um „Bild zu Video“ oder „Performance- & Bewegungsrekonstruktion“ zu nutzen.',
        step3Title: 'Video generieren',
        step3Description:
            'Lege Parameter fest (z. B. 16:9, 15 Sekunden) und klicke auf „Generieren“. Nach kurzer Zeit kannst du dein Video mit Sound ansehen und herunterladen.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube‑Videos über das Wan 2.6 Videomodell',

        // X Posts 部分
        xPostsTitle: 'Beliebte X‑Posts über das Wan 2.6 KI‑Videomodell',

        // 探索其他模型部分
        exploreModelsTitle: 'Weitere Modelle entdecken',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 KI‑Videogenerator',
        sora2Title: 'OpenAI Sora‑2 KI‑Videogenerator',

        // FAQ 部分
        faqTitle: 'Häufige Fragen',
        faq1Question: 'Was ist Wan 2.6?',
        faq1Answer:
            'Wan 2.6 ist das neueste KI‑Videogenerierungsmodell von Alibaba Cloud – mit filmreifer Bildqualität, nativer Audio‑Visual‑Sync‑Generierung und intelligentem Multi‑Shot‑Storytelling.',
        faq2Question: 'Was ist das Besondere an Wan 2.6?',
        faq2Answer:
            'Das wichtigste Merkmal ist „Native Audio‑Visual Sync“. Es erzeugt nicht nur das Video, sondern gleichzeitig passende Umgebungsgeräusche und Stimmen – ohne aufwändiges Nachvertonen. Außerdem ist die Multi‑Shot‑Konsistenz hervorragend.',
        faq3Question: 'Ist Wan 2.6 auf 微鲤AI kostenlos?',
        faq3Answer:
            '微鲤AI bietet registrierten Nutzern kostenlose Credits, um die Basisfunktionen von Wan 2.6 auszuprobieren. HD‑ und längere (15‑Sekunden) Videos können mehr Credits verbrauchen oder ein Pro‑Upgrade erfordern.',
        faq4Question: 'Wie lang sind die generierten Videos?',
        faq4Answer:
            'Derzeit werden Clips mit 5 Sekunden, 10 Sekunden und bis zu 15 Sekunden unterstützt. Mit der Multi‑Shot‑Funktion kann eine einzelne 15‑Sekunden‑Generierung viele Story‑Beats enthalten.',
        faq5Question: 'Welche Eingabemodi werden unterstützt?',
        faq5Answer:
            'Unterstützt werden „Text zu Video“ (Text-to-Video), „Bild zu Video“ (Image-to-Video) sowie „Video‑zu‑Video“ (Video-to-Video/Performance‑Rekonstruktion) – von der Idee bis zum Asset.',
        faq6Question: 'Was ist der Unterschied zwischen Wan 2.6 und Wan 2.5?',
        faq6Answer:
            'Wan 2.6 ist eine vollständig aktualisierte, kommerzielle (API) Version: Die Auflösung steigt von 720p auf 1080p, Audiogenerierung kommt hinzu und Bewegungsflüssigkeit sowie Prompt‑Treue werden deutlich verbessert.',

        // CTA 部分
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription:
            'Teste Wan 2.6 jetzt und verwandle deine Ideen in beeindruckende Videos',
        ctaButton: 'Wan 2.6 jetzt testen',
        ctaDisclaimer:
            'Keine Kreditkarte erforderlich — registrieren und loslegen',

        // 视频播放相关
        videoNotSupported: 'Dein Browser unterstützt die Videowiedergabe nicht',
        videoLoadingError: 'Video konnte nicht geladen werden',
        videoReload: 'Neu laden',
    },
    ru: {
        // 页面标题和描述
        pageTitle:
            'Генератор видео Wan 2.6 - Платформа создания видео с мультимодальным ИИ нового поколения',
        pageDescription:
            'Попробуйте Wan 2.6 — флагманскую мультимодальную модель генерации видео. Она создаёт кинематографическое видео 1080p и предлагает прорыв Native Audio-Visual Sync: картинка и синхронный звук (эффекты, голос) генерируются за один проход. Бесплатно на 微鲤AI.',
        pageKeywords:
            'Wan 2.6, генератор видео ИИ, мультимодальная модель видео ИИ, нативная аудио-визуальная синхронизация, 1080p кино, умный сторибординг, бесплатное ИИ видео, 微鲤AI, создание видео',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 — флагманская мультимодальная модель генерации видео',
        short_title: 'Мультимодальная модель ИИ для видео',
        generatorDescription:
            'Wan 2.6 — новейшая флагманская мультимодальная модель генерации видео от команды Tongyi Wanxiang (Wanx) Alibaba Cloud. Это крупное обновление серии Wan: помимо кинематографического 1080p, модель делает прорыв в Native Audio-Visual Sync — генерирует изображение вместе с подходящими звуковыми эффектами и голосом за один проход. Wan 2.6 создана для сложных задач длинного повествования и включает умное многокадровое сторибордирование, позволяющее до 15 секунд связной мультикадровой генерации, чтобы создатели могли перейти “от сценария к финальному монтажу”. Попробуйте Wan 2.6 бесплатно на 微鲤AI и откройте новую эру ИИ‑творчества — со звуком и картинкой.',
        generatorDescriptionHighlight1:
            'Wan 2.6 уже интегрирована в видеогенератор 微鲤AI и создаёт реалистичные видео',
        generatorDescriptionText2: '. Нажмите здесь, чтобы',
        generatorDescriptionHighlight2: 'попробовать Wan 2.6 бесплатно',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Изображение → Видео',
        tabTextToVideo: 'Текст → Видео',

        // 核心功能部分
        coreFeaturesTitle: 'Ключевые возможности Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle:
            'Нативная генерация с аудио‑визуальной синхронизацией',
        nativeAudioIntegrationDescription:
            'Wan 2.6 стирает границу между изображением и звуком: одновременно с видеорядом она автоматически генерирует точно синхронизированный звук (например, шаги, дождь) и даже реплики с лип‑синком, предоставляя полноценные аудио‑визуальные материалы без пост‑дубляжа.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle:
            'Интеллектуальный многокадровый сторителлинг',
        enhancedDynamicEffectsDescription:
            'Благодаря сильному семантическому пониманию модель разбивает сложный длинный промпт на несколько планов (например, общий → крупный) и сохраняет высокую согласованность персонажей, сцен и света между планами — так за одну генерацию получается цельная мини‑история.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Реконструкция игры и движений',
        preciseCameraControlDescription:
            'С “video‑to‑video” вы можете загрузить реальный ролик‑референс. Wan 2.6 точно переносит амплитуду движений, мимику и даже ритм камеры на нового виртуального персонажа (например, аниме или 3D), реализуя “ИИ‑моушн‑кэпчер”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle:
            'Связная генерация длинного видео до 15 секунд',
        enhancedVisualRealismDescription:
            'Генерируйте до 15 секунд HD‑видео 1080p/24fps. По сравнению с короткими клипами традиционных моделей Wan 2.6 даёт больше времени для сложных действий и изменений окружения, сохраняя стабильное качество на всём протяжении.',

        // 如何使用部分
        howToUseTitle: 'Как пользоваться Wan 2.6 на 微鲤AI',
        step1Title: 'Выберите модель',
        step1Description: 'В инструменте AI Video выберите модель Wan 2.6',
        step2Title: 'Введите контент',
        step2Description:
            'Опишите желаемую сцену в текстовом поле или загрузите референс‑изображение/видео, чтобы включить “Изображение → Видео” или “Реконструкция игры и движений”.',
        step3Title: 'Сгенерируйте видео',
        step3Description:
            'Настройте параметры (например, 16:9 и длительность 15 секунд), нажмите “Сгенерировать” — через пару мгновений сможете просмотреть и скачать видео со звуком.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube‑видео о видеомодели Wan 2.6',

        // X Posts 部分
        xPostsTitle: 'Популярные посты в X о модели AI‑видео Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'Посмотреть другие модели',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Генератор AI‑видео Google Veo 3.1',
        sora2Title: 'Генератор AI‑видео OpenAI Sora‑2',

        // FAQ 部分
        faqTitle: 'Часто задаваемые вопросы',
        faq1Question: 'Что такое Wan 2.6?',
        faq1Answer:
            'Wan 2.6 — это новейшая модель генерации AI‑видео от Alibaba Cloud с кинематографическим качеством, нативной аудио‑визуальной синхронизацией и умным многокадровым сторителлингом.',
        faq2Question: 'В чём главная особенность Wan 2.6?',
        faq2Answer:
            'Главная особенность — “Native Audio‑Visual Sync”. Модель генерирует не только видео, но и подходящий фоновой звук и голоса одновременно, избавляя от сложного пост‑дубляжа. Также у неё отличная согласованность между кадрами.',
        faq3Question: 'Wan 2.6 на 微鲤AI — это бесплатно?',
        faq3Answer:
            '微鲤AI предоставляет зарегистрированным пользователям бесплатные кредиты для знакомства с базовыми функциями Wan 2.6. Генерация HD‑видео и более длинных роликов (15 секунд) может требовать больше кредитов или обновления до Pro.',
        faq4Question: 'Какой длины получаются видео?',
        faq4Answer:
            'Сейчас поддерживаются клипы на 5 секунд, 10 секунд и до 15 секунд. Благодаря функции multi‑shot один 15‑секундный результат может включать насыщенные сюжетные повороты.',
        faq5Question: 'Какие режимы ввода поддерживаются?',
        faq5Answer:
            'Поддерживаются “Text‑to‑Video”, “Image‑to‑Video” и “Video‑to‑Video” (реконструкция/повтор исполнения), чтобы закрыть потребности от идеи до готовых материалов.',
        faq6Question: 'Чем Wan 2.6 отличается от Wan 2.5?',
        faq6Answer:
            'Wan 2.6 — полностью обновлённая коммерческая (API) версия: разрешение повышено с 720p до 1080p, добавлена генерация аудио и существенно улучшены плавность движений и следование инструкциям.',

        // CTA 部分
        ctaTitle: 'Готовы начать творить?',
        ctaDescription:
            'Попробуйте Wan 2.6 прямо сейчас и превратите идеи в отличные видео',
        ctaButton: 'Попробовать Wan 2.6',
        ctaDisclaimer: 'Без кредитной карты — зарегистрируйтесь и начинайте',

        // 视频播放相关
        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadingError: 'Не удалось загрузить видео',
        videoReload: 'Перезагрузить',
    },
    pt: {
        // 页面标题和描述
        pageTitle:
            'Gerador de vídeo Wan 2.6 - Plataforma de criação de vídeo com IA multimodal de nova geração',
        pageDescription:
            'Experimente o Wan 2.6, o modelo multimodal flagship de geração de vídeo por IA. Ele entrega vídeo 1080p com qualidade cinematográfica e um avanço em Native Audio-Visual Sync: gera imagem e áudio (efeitos e voz) sincronizados em uma única execução. Teste grátis na 微鲤AI.',
        pageKeywords:
            'Wan 2.6, gerador de vídeo IA, modelo de vídeo IA multimodal, sincronização nativa áudio-visual, 1080p cinematográfico, storyboard inteligente, vídeo IA grátis, 微鲤AI, criação de vídeo',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 - Modelo multimodal flagship de geração de vídeo por IA',
        short_title: 'Modelo de vídeo de IA multimodal',
        generatorDescription:
            'Wan 2.6 é o mais recente modelo multimodal flagship lançado pela equipe Tongyi Wanxiang (Wanx) da Alibaba Cloud. Como uma grande atualização da série Wan, ele não só suporta saída 1080p com qualidade cinematográfica, como também traz um avanço em Native Audio-Visual Sync — gerando o vídeo junto com efeitos sonoros e vozes compatíveis em uma única passada. Criado para enfrentar os desafios de narrativas mais longas, o Wan 2.6 conta com storyboard inteligente multi‑cenas, permitindo até 15 segundos de criação coerente com múltiplos planos e ajudando criadores a ir “do roteiro ao corte final”. Experimente o Wan 2.6 grátis na 微鲤AI e entre numa nova era de criação com IA, com imagem e som.',
        generatorDescriptionHighlight1:
            'O Wan 2.6 já está integrado ao gerador de vídeo da 微鲤AI para criar vídeos realistas',
        generatorDescriptionText2: '. Clique aqui para',
        generatorDescriptionHighlight2: 'testar o Wan 2.6 grátis',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Imagem para vídeo',
        tabTextToVideo: 'Texto para vídeo',

        // 核心功能部分
        coreFeaturesTitle: 'Principais recursos do Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle:
            'Geração com sincronização nativa áudio‑visual',
        nativeAudioIntegrationDescription:
            'O Wan 2.6 rompe a barreira entre visão e audição: ao mesmo tempo em que gera o vídeo, cria automaticamente áudio sincronizado com precisão (ex.: passos, chuva) e até diálogos com lip‑sync, entregando materiais audiovisuais completos sem dublagem posterior.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle:
            'Storytelling inteligente em múltiplas cenas',
        enhancedDynamicEffectsDescription:
            'Com forte compreensão semântica, o modelo decompõe um prompt longo e complexo em várias cenas (ex.: plano geral para close) e mantém alta consistência de personagem, cenário e iluminação entre as cenas, contando uma mini‑história completa em uma única geração.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Reencenação de performance e movimento',
        preciseCameraControlDescription:
            'Com “vídeo para vídeo”, você pode enviar um clipe de performance real como referência. O Wan 2.6 transfere com precisão a amplitude dos movimentos, expressões faciais e até o ritmo de câmera para um personagem virtual recém‑gerado (ex.: anime ou 3D), realizando “captura de movimento com IA”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle:
            'Geração coerente de vídeo longo de 15 segundos',
        enhancedVisualRealismDescription:
            'Gere até 15 segundos de vídeo HD em 1080p/24fps. Em comparação com clipes curtos de modelos tradicionais, o Wan 2.6 oferece mais tempo para mostrar ações complexas e mudanças de ambiente, mantendo qualidade estável do começo ao fim.',

        // 如何使用部分
        howToUseTitle: 'Como usar o Wan 2.6 na 微鲤AI',
        step1Title: 'Escolha o modelo',
        step1Description:
            'Selecione o modelo Wan 2.6 na ferramenta de vídeo com IA',
        step2Title: 'Insira o conteúdo',
        step2Description:
            'Descreva a cena na caixa de texto ou envie uma imagem/vídeo de referência para ativar “Imagem para vídeo” ou “Reencenação de performance e movimento”.',
        step3Title: 'Gerar vídeo',
        step3Description:
            'Defina os parâmetros (ex.: proporção 16:9, duração de 15 s), clique em “Gerar” e em instantes você poderá visualizar e baixar seu vídeo com som.',

        // YouTube 视频部分
        youtubeTitle: 'Vídeos no YouTube sobre o modelo de vídeo Wan 2.6',

        // X Posts 部分
        xPostsTitle: 'Posts em alta no X sobre o modelo de vídeo IA Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'Explorar outros modelos',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Gerador de vídeo IA Google Veo 3.1',
        sora2Title: 'Gerador de vídeo IA OpenAI Sora-2',

        // FAQ 部分
        faqTitle: 'Perguntas frequentes',
        faq1Question: 'O que é o Wan 2.6?',
        faq1Answer:
            'Wan 2.6 é o modelo mais recente de geração de vídeo por IA da Alibaba Cloud, com qualidade cinematográfica, sincronização nativa áudio‑visual e storytelling inteligente em múltiplas cenas.',
        faq2Question: 'Qual é o principal diferencial do Wan 2.6?',
        faq2Answer:
            'O maior destaque é a “sincronização nativa áudio‑visual”. Ele não só gera o vídeo, como também cria ao mesmo tempo sons ambientes e vozes compatíveis, eliminando a necessidade de dublagem posterior. Além disso, a consistência multi‑cenas é excelente.',
        faq3Question: 'O Wan 2.6 é gratuito na 微鲤AI?',
        faq3Answer:
            'A 微鲤AI oferece créditos gratuitos para usuários cadastrados testarem os recursos básicos do Wan 2.6. Gerar vídeos em HD e mais longos (15 s) pode consumir mais créditos ou exigir upgrade para Pro.',
        faq4Question: 'Qual é a duração dos vídeos gerados?',
        faq4Answer:
            'Atualmente, são suportados clipes de 5 s, 10 s e até 15 s. Com o recurso de múltiplas cenas, uma única geração de 15 s pode trazer uma narrativa rica.',
        faq5Question: 'Quais modos de entrada ele suporta?',
        faq5Answer:
            'Suporta “Text-to-Video”, “Image-to-Video” e “Video-to-Video” (reencenação), cobrindo a criação do insight até o material final.',
        faq6Question: 'Qual a diferença entre Wan 2.6 e Wan 2.5?',
        faq6Answer:
            'Wan 2.6 é uma versão comercial (API) totalmente atualizada: a resolução sobe de 720p para 1080p, adiciona geração de áudio e melhora significativamente a fluidez do movimento e o seguimento de instruções.',

        // CTA 部分
        ctaTitle: 'Pronto para começar a criar?',
        ctaDescription:
            'Experimente o Wan 2.6 agora e transforme suas ideias em vídeos incríveis',
        ctaButton: 'Experimentar Wan 2.6 agora',
        ctaDisclaimer: 'Sem cartão de crédito — cadastre-se para começar',

        // 视频播放相关
        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadingError: 'Falha ao carregar o vídeo',
        videoReload: 'Recarregar',
    },
    it: {
        // 页面标题和描述
        pageTitle:
            'Generatore video Wan 2.6 - Piattaforma di creazione video AI multimodale di nuova generazione',
        pageDescription:
            'Prova Wan 2.6, il modello multimodale di punta per la generazione di video con AI. Offre video 1080p in qualità cinematografica e un salto con Native Audio-Visual Sync: genera immagini e audio (effetti e voce) sincronizzati in un’unica esecuzione. Provalo gratis su 微鲤AI.',
        pageKeywords:
            'Wan 2.6, generatore video AI, modello video AI multimodale, sincronizzazione nativa audio-visiva, 1080p cinematografico, storyboard intelligente, video AI gratis, 微鲤AI, creazione video',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 - Modello multimodale di punta per la generazione video con AI',
        short_title: 'Modello video IA multimodale',
        generatorDescription:
            'Wan 2.6 è il più recente modello multimodale di punta rilasciato dal team Tongyi Wanxiang (Wanx) di Alibaba Cloud. Come grande aggiornamento della serie Wan, non solo supporta output 1080p in qualità cinematografica, ma raggiunge anche un progresso con Native Audio-Visual Sync, generando il video insieme a effetti sonori e voci coerenti in un solo passaggio. Pensato per affrontare la narrativa nei video lunghi, Wan 2.6 include uno storyboard intelligente multi‑inquadratura che consente fino a 15 secondi di creazione coerente multi‑shot, aiutando i creator a passare “dalla sceneggiatura al montaggio finale”. Prova Wan 2.6 gratis su 微鲤AI e vivi una nuova era di creazione AI, con immagini e suono.',
        generatorDescriptionHighlight1:
            'Wan 2.6 è ora integrato nel generatore video 微鲤AI per creare video realistici',
        generatorDescriptionText2: '. Clicca qui per',
        generatorDescriptionHighlight2: 'provare Wan 2.6 gratis',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Immagine → Video',
        tabTextToVideo: 'Testo → Video',

        // 核心功能部分
        coreFeaturesTitle: 'Funzionalità chiave di Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle:
            'Generazione con sincronizzazione nativa audio‑visiva',
        nativeAudioIntegrationDescription:
            'Wan 2.6 supera il confine tra vista e udito: mentre genera il video, crea automaticamente audio sincronizzato con precisione (es. passi, pioggia) e persino dialoghi con lip‑sync, fornendo asset audiovisivi completi senza doppiaggio in post‑produzione.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle:
            'Storytelling intelligente multi‑inquadratura',
        enhancedDynamicEffectsDescription:
            'Grazie a una forte comprensione semantica, il modello può scomporre un prompt lungo e complesso in più inquadrature (es. campo lungo → primo piano) e mantenere alta coerenza di personaggi, scena e illuminazione tra le inquadrature, raccontando una mini‑storia completa in una sola generazione.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Re-enactment di performance e movimento',
        preciseCameraControlDescription:
            'Con “video‑to‑video” puoi caricare una clip di performance reale come riferimento. Wan 2.6 trasferisce con precisione ampiezza dei movimenti, espressioni facciali e persino il ritmo della camera su un personaggio virtuale appena generato (es. anime o 3D), ottenendo una “motion capture con AI”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle:
            'Generazione coerente di video lunghi fino a 15 secondi',
        enhancedVisualRealismDescription:
            'Genera fino a 15 secondi di video HD 1080p/24fps. Rispetto ai clip brevi dei modelli tradizionali, Wan 2.6 offre più tempo per mostrare azioni complesse e cambi ambientali, mantenendo una qualità stabile dall’inizio alla fine.',

        // 如何使用部分
        howToUseTitle: 'Come usare Wan 2.6 su 微鲤AI',
        step1Title: 'Scegli il modello',
        step1Description:
            'Nello strumento AI Video, seleziona il modello Wan 2.6',
        step2Title: 'Inserisci il contenuto',
        step2Description:
            'Descrivi la scena nella casella di testo oppure carica un’immagine/video di riferimento per attivare “Immagine → Video” o “Re-enactment di performance e movimento”.',
        step3Title: 'Genera il video',
        step3Description:
            'Imposta i parametri (es. formato 16:9, durata 15 s), fai clic su “Genera” e dopo poco potrai visualizzare e scaricare il tuo video con audio.',

        // YouTube 视频部分
        youtubeTitle: 'Video YouTube sul modello video Wan 2.6',

        // X Posts 部分
        xPostsTitle: 'Post X di tendenza sul modello video AI Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'Esplora altri modelli',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Generatore video AI Google Veo 3.1',
        sora2Title: 'Generatore video AI OpenAI Sora-2',

        // FAQ 部分
        faqTitle: 'Domande frequenti',
        faq1Question: 'Che cos’è Wan 2.6?',
        faq1Answer:
            'Wan 2.6 è l’ultimo modello di generazione video AI di Alibaba Cloud, con qualità cinematografica, sincronizzazione nativa audio‑visiva e storytelling intelligente multi‑inquadratura.',
        faq2Question: 'Qual è la caratteristica principale di Wan 2.6?',
        faq2Answer:
            'La caratteristica più distintiva è la “sincronizzazione nativa audio‑visiva”. Non solo genera il video, ma anche suoni ambientali e voci coerenti nello stesso momento, evitando il doppiaggio in post‑produzione. Inoltre, la coerenza tra le inquadrature è eccellente.',
        faq3Question: 'Wan 2.6 su 微鲤AI è gratuito?',
        faq3Answer:
            '微鲤AI offre crediti gratuiti agli utenti registrati per provare le funzionalità di base di Wan 2.6. Generare video HD e più lunghi (15 s) può consumare più crediti o richiedere l’upgrade a Pro.',
        faq4Question: 'Quanto durano i video generati?',
        faq4Answer:
            'Attualmente supporta clip da 5 s, 10 s e fino a 15 s. Con la funzione multi‑shot, una singola generazione di 15 s può includere una narrazione ricca.',
        faq5Question: 'Quali modalità di input supporta?',
        faq5Answer:
            'Supporta “Text-to-Video”, “Image-to-Video” e “Video-to-Video” (re-enactment), coprendo la creazione dall’idea fino ai materiali.',
        faq6Question: 'Qual è la differenza tra Wan 2.6 e Wan 2.5?',
        faq6Answer:
            'Wan 2.6 è una versione commerciale (API) completamente aggiornata: la risoluzione passa da 720p a 1080p, aggiunge la generazione audio e migliora notevolmente la fluidità dei movimenti e l’aderenza alle istruzioni.',

        // CTA 部分
        ctaTitle: 'Pronto a iniziare a creare?',
        ctaDescription:
            'Prova Wan 2.6 ora e trasforma le tue idee in video fantastici',
        ctaButton: 'Prova Wan 2.6 ora',
        ctaDisclaimer:
            'Nessuna carta di credito richiesta — registrati per iniziare',

        // 视频播放相关
        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadingError: 'Impossibile caricare il video',
        videoReload: 'Ricarica',
    },
    ar: {
        // 页面标题和描述
        pageTitle:
            'مولّد الفيديو Wan 2.6 - منصة إنشاء فيديو بالذكاء الاصطناعي متعدد الوسائط من الجيل الجديد',
        pageDescription:
            'جرّب Wan 2.6، نموذجًا رائدًا لتوليد الفيديو بالذكاء الاصطناعي متعدد الوسائط. يقدّم فيديو 1080p بجودة سينمائية مع طفرة في Native Audio-Visual Sync: توليد الصورة والصوت المتزامن (المؤثرات والصوت البشري) دفعة واحدة. جرّبه مجانًا على 微鲤AI.',
        pageKeywords:
            'Wan 2.6, مولد فيديو بالذكاء الاصطناعي, نموذج فيديو متعدد الوسائط, مزامنة أصلية للصوت والصورة, 1080p سينمائي, ستوري بورد ذكي, فيديو بالذكاء الاصطناعي مجاني, 微鲤AI, إنشاء الفيديو',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 - النموذج الرائد متعدد الوسائط لتوليد الفيديو بالذكاء الاصطناعي',
        short_title: 'نموذج فيديو ذكاء اصطناعي متعدد الوسائط',
        generatorDescription:
            'Wan 2.6 هو أحدث نموذج رائد متعدد الوسائط لتوليد الفيديو بالذكاء الاصطناعي أطلقه فريق Tongyi Wanxiang (Wanx) من Alibaba Cloud. وبصفته ترقية كبرى لسلسلة Wan، فهو لا يدعم إخراج 1080p بجودة سينمائية فحسب، بل يحقق أيضًا إنجازًا في Native Audio-Visual Sync عبر توليد المشهد مع المؤثرات الصوتية والأصوات المتطابقة في تمريرة واحدة. صُمّم Wan 2.6 لحل تحديات السرد في الفيديوهات الطويلة، ويضم ميزة تقسيم اللقطات الذكية متعددة المشاهد التي تتيح حتى 15 ثانية من إنشاء متماسك متعدد اللقطات، لمساعدة المبدعين على الانتقال “من النص إلى النسخة النهائية”. جرّب Wan 2.6 مجانًا على 微鲤AI وادخل عصرًا جديدًا من الإبداع بالذكاء الاصطناعي مع الصورة والصوت.',
        generatorDescriptionHighlight1:
            'تم دمج Wan 2.6 الآن في مولّد الفيديو 微鲤AI لإنشاء فيديوهات واقعية',
        generatorDescriptionText2: '. انقر هنا لـ',
        generatorDescriptionHighlight2: 'تجربة Wan 2.6 مجانًا',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',

        // 核心功能部分
        coreFeaturesTitle: 'الميزات الأساسية في Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'توليد بمزامنة أصلية للصوت والصورة',
        nativeAudioIntegrationDescription:
            'يكسر Wan 2.6 الحاجز بين البصر والسمع: أثناء توليد الفيديو، يمكنه إنشاء صوت متزامن بدقة (مثل خطوات الأقدام والمطر) وحتى حوار مع تزامن حركة الشفاه، لتقديم مواد سمعية‑بصرية مكتملة دون دبلجة لاحقة.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'سرد ذكي متعدد اللقطات',
        enhancedDynamicEffectsDescription:
            'بفضل فهم دلالي قوي، يستطيع النموذج تفكيك تعليمات طويلة ومعقدة إلى عدة لقطات (مثل لقطة عامة ثم مقرّبة)، مع الحفاظ على اتساق الشخصية والمشهد والإضاءة بين اللقطات، ليروي قصة قصيرة كاملة في توليد واحد.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'إعادة تمثيل الأداء والحركة',
        preciseCameraControlDescription:
            'باستخدام “video-to-video”، يمكنك رفع مقطع أداء حقيقي كمرجع. يستطيع Wan 2.6 نقل مدى الحركة وتعابير الوجه وحتى إيقاع حركة الكاميرا بدقة إلى شخصية افتراضية مُولّدة حديثًا (مثل الأنمي أو 3D)، محققًا “التقاط حركة بالذكاء الاصطناعي”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'توليد فيديو طويل متماسك حتى 15 ثانية',
        enhancedVisualRealismDescription:
            'ولّد حتى 15 ثانية من فيديو HD بدقة 1080p/24fps. مقارنة بالمقاطع القصيرة في النماذج التقليدية، يمنح Wan 2.6 وقتًا أطول لإظهار الحركات المعقدة وتغيّر البيئة مع الحفاظ على جودة ثابتة طوال المقطع.',

        // 如何使用部分
        howToUseTitle: 'كيفية استخدام Wan 2.6 على 微鲤AI',
        step1Title: 'اختر النموذج',
        step1Description: 'اختر نموذج Wan 2.6 داخل أداة فيديو الذكاء الاصطناعي',
        step2Title: 'أدخل المحتوى',
        step2Description:
            'صف المشهد الذي تريده في مربع النص، أو ارفع صورة/فيديو مرجعي لتفعيل “صورة إلى فيديو” أو “إعادة تمثيل الأداء والحركة”.',
        step3Title: 'ولّد الفيديو',
        step3Description:
            'اضبط الإعدادات (مثل نسبة 16:9 ومدة 15 ثانية)، ثم اضغط “توليد”. بعد لحظات يمكنك المعاينة والتنزيل لفيديوك مع الصوت.',

        // YouTube 视频部分
        youtubeTitle: 'فيديوهات YouTube عن نموذج الفيديو Wan 2.6',

        // X Posts 部分
        xPostsTitle:
            'منشورات X الرائجة عن نموذج فيديو الذكاء الاصطناعي Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'استكشف نماذج أخرى',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'مولّد فيديو بالذكاء الاصطناعي Google Veo 3.1',
        sora2Title: 'مولّد فيديو بالذكاء الاصطناعي OpenAI Sora-2',

        // FAQ 部分
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'ما هو Wan 2.6؟',
        faq1Answer:
            'Wan 2.6 هو أحدث نموذج لتوليد الفيديو بالذكاء الاصطناعي من Alibaba Cloud، ويتميز بجودة سينمائية وتوليد بمزامنة أصلية للصوت والصورة وسرد ذكي متعدد اللقطات.',
        faq2Question: 'ما أبرز ما يميز Wan 2.6؟',
        faq2Answer:
            'الميزة الأبرز هي “المزامنة الأصلية للصوت والصورة”. فهو لا يولّد الفيديو فقط، بل يولّد أيضًا الصوت المحيط والأصوات المتطابقة في الوقت نفسه، ما يلغي تعقيد الدبلجة اللاحقة. كما أن اتساق اللقطات المتعددة ممتاز.',
        faq3Question: 'هل استخدام Wan 2.6 على 微鲤AI مجاني؟',
        faq3Answer:
            'توفّر 微鲤AI رصيدًا مجانيًا للمستخدمين المسجّلين لتجربة الميزات الأساسية لـ Wan 2.6. قد يتطلب توليد فيديوهات HD وطويلة (15 ثانية) رصيدًا أكثر أو الترقية إلى Pro.',
        faq4Question: 'كم تبلغ مدة الفيديوهات المُولّدة؟',
        faq4Answer:
            'يدعم حاليًا مقاطع 5 ثوانٍ و10 ثوانٍ وحتى 15 ثانية. ومع ميزة تعدد اللقطات، يمكن لتوليد واحد لمدة 15 ثانية أن يتضمن أحداثًا غنية.',
        faq5Question: 'ما أوضاع الإدخال التي يدعمها؟',
        faq5Answer:
            'يدعم “Text-to-Video” و“Image-to-Video” و“Video-to-Video” (إعادة التمثيل)، لتغطية احتياجات الإنشاء من الفكرة حتى المواد.',
        faq6Question: 'ما الفرق بين Wan 2.6 وWan 2.5؟',
        faq6Answer:
            'Wan 2.6 هو إصدار تجاري (API) مطوّر بالكامل: ارتفعت الدقة من 720p إلى 1080p، وأضيف توليد الصوت، وتحسّنت بشكل كبير سلاسة الحركة والالتزام بالتعليمات.',

        // CTA 部分
        ctaTitle: 'هل أنت مستعد لبدء الإبداع؟',
        ctaDescription: 'جرّب Wan 2.6 الآن وحوّل أفكارك إلى فيديوهات رائعة',
        ctaButton: 'جرّب Wan 2.6 الآن',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان — سجّل لتبدأ',

        // 视频播放相关
        videoNotSupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoLoadingError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة التحميل',
        },
    th: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 Video Generator - แพลตฟอร์มสร้างวิดีโอ AI มัลติโหมดรุ่นใหม่',
        pageDescription:
            'ลอง Wan 2.6 โมเดลสร้างวิดีโอ AI มัลติโหมดระดับเรือธง ให้ภาพระดับภาพยนตร์ 1080p และการซิงก์เสียง-ภาพแบบเนทีฟ สร้างภาพพร้อมเอฟเฟกต์เสียงและเสียงพูดในครั้งเดียว ทดลองใช้ฟรีบน 微鲤AI',
        pageKeywords:
            'Wan 2.6, เครื่องมือสร้างวิดีโอ AI, โมเดลวิดีโอ AI มัลติโหมด, ซิงก์เสียง-ภาพแบบเนทีฟ, 1080p ระดับภาพยนตร์, สตอรี่บอร์ดอัจฉริยะ, วิดีโอ AI ฟรี, 微鲤AI, การสร้างวิดีโอ',

        // 生成器部分
        generatorTitle: 'โมเดลสร้างวิดีโอ AI มัลติโหมดระดับเรือธง Wan 2.6',
        short_title: 'โมเดลวิดีโอ AI มัลติโหมด',
        generatorDescription:
            'Wan 2.6 คือโมเดลสร้างวิดีโอ AI มัลติโหมดระดับเรือธงรุ่นล่าสุดจากทีม Tongyi Wanxiang (Wanx) ของ Alibaba Cloud ในฐานะการอัปเกรดครั้งใหญ่ของตระกูล Wan นอกจากรองรับเอาต์พุตระดับภาพยนตร์ 1080p แล้วยังสร้างความก้าวหน้าด้วยการซิงก์เสียง-ภาพแบบเนทีฟ สร้างภาพพร้อมเอฟเฟกต์เสียงและเสียงพูดในครั้งเดียว ออกแบบมาเพื่อการเล่าเรื่องแบบยาว Wan 2.6 มาพร้อมสตอรี่บอร์ดหลายช็อตอัจฉริยะที่สร้างวิดีโอหลายมุมกล้องอย่างต่อเนื่องได้สูงสุด 15 วินาที ช่วยให้ครีเอเตอร์ไปจากสคริปต์สู่ชิ้นงานสุดท้ายได้ ลอง Wan 2.6 ฟรีบน 微鲤AI แล้วก้าวสู่ยุคใหม่ของ “วิดีโอมีเสียง สร้างโดย AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 ถูกผสานเข้ากับเครื่องมือสร้างวิดีโอ 微鲤AI เพื่อสร้างวิดีโอสมจริงแล้ว',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'ลอง Wan 2.6 ฟรี',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // 核心功能部分
        coreFeaturesTitle: 'คุณสมบัติเด่นของ Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'การสร้างซิงก์เสียง-ภาพแบบเนทีฟ',
        nativeAudioIntegrationDescription:
            'Wan 2.6 ทำลายขีดจำกัดระหว่างภาพและเสียง ระหว่างสร้างวิดีโอสามารถสร้างเสียงที่ซิงก์อย่างแม่นยำ (เช่น เสียงเท้า เสียงฝน) และแม้แต่ลิปซิงก์บทสนทนา ทำให้ได้ชิ้นงานภาพ-เสียงครบโดยไม่ต้องพากย์ทีหลัง',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'การเล่าเรื่องหลายช็อตอัจฉริยะ',
        enhancedDynamicEffectsDescription:
            'ด้วยความเข้าใจเชิงความหมายที่แข็งแรง โมเดลสามารถแยกพรอมต์ยาวและซับซ้อนเป็นหลายช็อต (เช่น มุมกว้างไปโคลสอัป) พร้อมคงเอกลักษณ์ตัวละคร ฉาก และแสงให้สอดคล้องกันตลอด เพื่อเล่าเรื่องสั้นให้จบในครั้งเดียว',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'การรีเอนแอคท์การแสดงและการเคลื่อนไหว',
        preciseCameraControlDescription:
            'ด้วย “video-to-video” คุณสามารถอัปโหลดคลิปการแสดงจริงเป็นอ้างอิง Wan 2.6 จะถ่ายทอดช่วงการเคลื่อนไหว สีหน้า และแม้แต่จังหวะกล้องไปยังตัวละครเสมือนใหม่ (เช่น อนิเมะหรือ 3D) เสมือน “AI motion capture”',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'การสร้างวิดีโอยาว 15 วินาทีแบบต่อเนื่อง',
        enhancedVisualRealismDescription:
            'สร้างวิดีโอ HD 1080p/24fps ได้ยาวถึง 15 วินาที เมื่อเทียบกับคลิปสั้นจากโมเดลเดิม Wan 2.6 มีเวลามากขึ้นในการถ่ายทอดการกระทำที่ซับซ้อนและการเปลี่ยนแปลงสภาพแวดล้อม โดยคงคุณภาพภาพที่เสถียรตลอด',

        // 如何使用部分
        howToUseTitle: 'วิธีใช้ Wan 2.6 บน 微鲤AI',
        step1Title: 'เลือกโมเดล',
        step1Description: 'เลือกโมเดล Wan 2.6 ในเครื่องมือ AI Video',
        step2Title: 'ป้อนเนื้อหา',
        step2Description:
            'อธิบายฉากที่ต้องการในกล่องข้อความ หรืออัปโหลดภาพ/วิดีโออ้างอิงเพื่อใช้ “Image to Video” หรือ “Performance & Motion Re-enactment”',
        step3Title: 'สร้างวิดีโอ',
        step3Description:
            'ตั้งค่าพารามิเตอร์ (เช่น อัตราส่วน 16:9 ความยาว 15 วินาที) คลิก “Generate” แล้วรอสักครู่เพื่อพรีวิวและดาวน์โหลดวิดีโอพร้อมเสียง',

        // YouTube 视频部分
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ Wan 2.6',

        // X Posts 部分
        xPostsTitle: 'โพสต์มาแรงบน X เกี่ยวกับโมเดลวิดีโอ AI Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'สำรวจโมเดลอื่น ๆ',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3.1',
        sora2Title: 'เครื่องมือสร้างวิดีโอ AI OpenAI Sora-2',

        // FAQ 部分
        faqTitle: 'คำถามที่พบบ่อย',
        faq1Question: 'Wan 2.6 คืออะไร?',
        faq1Answer:
            'Wan 2.6 คือโมเดลสร้างวิดีโอ AI รุ่นล่าสุดจาก Alibaba Cloud ที่โดดเด่นด้วยภาพระดับภาพยนตร์ การซิงก์เสียง-ภาพแบบเนทีฟ และการเล่าเรื่องหลายช็อตอัจฉริยะ',
        faq2Question: 'อะไรทำให้ Wan 2.6 พิเศษ?',
        faq2Answer:
            'จุดเด่นคือ “Native Audio-Visual Sync” ไม่เพียงสร้างวิดีโอ แต่ยังสร้างเสียงแวดล้อมและเสียงพูดที่ตรงกันพร้อมกัน ลดงานพากย์ภายหลัง และยังคงความสอดคล้องหลายช็อตได้ยอดเยี่ยม',
        faq3Question: 'ใช้ Wan 2.6 บน 微鲤AI ได้ฟรีไหม?',
        faq3Answer:
            '微鲤AI ให้เครดิตฟรีสำหรับผู้ใช้ที่ลงทะเบียนเพื่อทดลองฟีเจอร์พื้นฐานของ Wan 2.6 การสร้างวิดีโอ HD และยาว (15 วินาที) อาจใช้เครดิตมากขึ้นหรือต้องอัปเกรดเป็น Pro',
        faq4Question: 'วิดีโอที่สร้างยาวเท่าไร?',
        faq4Answer:
            'ขณะนี้รองรับคลิป 5 วินาที 10 วินาที และสูงสุด 15 วินาที ด้วยฟีเจอร์หลายช็อต การสร้างครั้งเดียว 15 วินาทีสามารถมีเหตุการณ์หลากหลายได้',
        faq5Question: 'รองรับโหมดอินพุตใดบ้าง?',
        faq5Answer:
            'รองรับ “Text-to-Video”, “Image-to-Video” และ “Video-to-Video” (การรีเอนแอคท์การแสดง) ครอบคลุมการสร้างตั้งแต่ไอเดียถึงชิ้นงาน',
        faq6Question: 'Wan 2.6 ต่างจาก Wan 2.5 อย่างไร?',
        faq6Answer:
            'Wan 2.6 คือเวอร์ชันเชิงพาณิชย์ (API) ที่อัปเกรดเต็มรูปแบบ ความละเอียดเพิ่มจาก 720p เป็น 1080p เพิ่มการสร้างเสียง และปรับปรุงความลื่นไหลของการเคลื่อนไหวกับการทำตามพรอมต์อย่างมาก',

        // CTA 部分
        ctaTitle: 'พร้อมเริ่มสร้างแล้วหรือยัง?',
        ctaDescription:
            'ลอง Wan 2.6 ตอนนี้และเปลี่ยนไอเดียให้เป็นวิดีโอสุดพิเศษ',
        ctaButton: 'ลอง Wan 2.6 ตอนนี้',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต — สมัครเพื่อเริ่มต้น',

        // 视频播放相关
        videoNotSupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoLoadingError: 'โหลดวิดีโอล้มเหลว',
        videoReload: 'โหลดใหม่',
        },
    da: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 videogenerator - næste generations multimodale AI-videoplatform',
        pageDescription:
            'Prøv Wan 2.6, en multimodal AI-videomodel i flagskibsklassen. Den leverer filmisk 1080p-video og et gennembrud i indbygget lyd-billedsynk—genererer billeder sammen med matchende lydeffekter og stemmer i ét hug. Gratis at prøve på 微鲤AI.',
        pageKeywords:
            'Wan 2.6, AI-videogenerator, multimodal AI-videomodel, indbygget lyd-billedsynk, filmisk 1080p, intelligent storyboarding, gratis AI-video, 微鲤AI, videoskabelse',

        // 生成器部分
        generatorTitle: 'Wan 2.6 flagskibs multimodal AI-videomodel',
        short_title: 'Multimodal AI-videomodel',
        generatorDescription:
            'Wan 2.6 er den nyeste multimodale AI-videomodel i flagskibsklassen fra Alibaba Clouds Tongyi Wanxiang (Wanx)-team. Som en stor opgradering i Wan-serien understøtter den ikke kun filmisk 1080p-output, men opnår også et gennembrud i indbygget lyd-billedsynk—den genererer billeder sammen med matchende lydeffekter og stemmer i én omgang. Wan 2.6 er skabt til long-form storytelling og har intelligent multi-shot storyboarding, der muliggør op til 15 sekunders sammenhængende, multi-kamera skabelse og hjælper skabere fra manuskript til færdig klipning. Prøv Wan 2.6 gratis på 微鲤AI og træd ind i en ny æra af “video med lyd, skabt af AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 er nu integreret i 微鲤AI-videogeneratoren for at skabe realistiske videoer',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'prøve Wan 2.6 gratis',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 nøglefunktioner',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Indbygget lyd-billedsynk-generering',
        nativeAudioIntegrationDescription:
            'Wan 2.6 bryder grænsen mellem syn og lyd—mens videoen genereres, kan den automatisk skabe præcist synkroniseret lyd (fx fodtrin, regn) og endda lip-sync til karakterdialog, så du får komplette audiovisuelle assets uden efterdubbing.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Intelligent multi-shot storytelling',
        enhancedDynamicEffectsDescription:
            'Med stærk semantisk forståelse kan modellen nedbryde en kompleks lang prompt til flere shots (fx total til nærbillede) og holde karakteridentitet, scener og lys meget konsistente på tværs af shots—så en komplet minihistorie fortælles i én generering.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performance- og bevægelsesre-enactment',
        preciseCameraControlDescription:
            'Med “video-to-video” kan du uploade et rigtigt performanceklip som reference. Wan 2.6 kan præcist overføre bevægelsesomfang, ansigtsudtryk og endda kamerapace til en nygenereret virtuel karakter (fx anime eller 3D) og muliggør “AI motion capture”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Sammenhængende 15-sekunders video',
        enhancedVisualRealismDescription:
            'Generér op til 15 sekunders 1080p/24fps HD-video. Sammenlignet med korte klip fra traditionelle modeller giver Wan 2.6 mere tid til at skildre komplekse handlinger og miljøændringer, mens visuelle kvaliteter forbliver stabile hele vejen.',

        // 如何使用部分
        howToUseTitle: 'Sådan bruger du Wan 2.6 på 微鲤AI',
        step1Title: 'Vælg en model',
        step1Description: 'Vælg Wan 2.6-modellen i AI Video-værktøjet',
        step2Title: 'Indtast dit indhold',
        step2Description:
            'Beskriv scenen i tekstfeltet, eller upload et referencebillede/-video for at aktivere “Image to Video” eller “Performance & Motion Re-enactment”.',
        step3Title: 'Generér videoen',
        step3Description:
            'Indstil parametre (fx 16:9-format, 15 sekunders længde), klik “Generate”, og vent et øjeblik for at forhåndsvise og downloade din video med lyd.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube-videoer om Wan 2.6 videomodellen',

        // X Posts 部分
        xPostsTitle: 'Trending X-opslag om Wan 2.6 AI-videomodel',

        // 探索其他模型部分
        exploreModelsTitle: 'Udforsk andre modeller',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Ofte stillede spørgsmål',
        faq1Question: 'Hvad er Wan 2.6?',
        faq1Answer:
            'Wan 2.6 er Alibaba Clouds nyeste AI-videomodel med filmisk billedkvalitet, indbygget lyd-billedsynk-generering og intelligent multi-shot storytelling.',
        faq2Question: 'Hvad gør Wan 2.6 særlig?',
        faq2Answer:
            'Den afgørende funktion er “Native Audio-Visual Sync”. Den genererer ikke kun videoen, men også matchende ambient lyd og stemmer samtidig—og eliminerer tidskrævende efterdubbing. Den leverer også fremragende konsistens på tværs af shots.',
        faq3Question: 'Er Wan 2.6 gratis at bruge på 微鲤AI?',
        faq3Answer:
            '微鲤AI giver gratis kreditter til registrerede brugere til at prøve Wan 2.6s basisfunktioner. Generering af HD og længere (15 sekunder) videoer kan bruge flere kreditter eller kræve Pro.',
        faq4Question: 'Hvor lange er de genererede videoer?',
        faq4Answer:
            'Den understøtter i øjeblikket klip på 5, 10 og op til 15 sekunder. Med multi-shot-funktionen kan en enkelt 15-sekunders generering indeholde rige historiepunkter.',
        faq5Question: 'Hvilke inputtilstande understøttes?',
        faq5Answer:
            'Den understøtter “Text-to-Video”, “Image-to-Video” og “Video-to-Video” (performance re-enactment), som dækker hele flowet fra idé til asset.',
        faq6Question: 'Hvad er forskellen på Wan 2.6 og Wan 2.5?',
        faq6Answer:
            'Wan 2.6 er en fuldt opgraderet kommerciel (API) version: opløsningen øges fra 720p til 1080p, lydgenerering er tilføjet, og bevægelsesglathed samt prompt-efterlevelse er markant forbedret.',

        // CTA 部分
        ctaTitle: 'Klar til at begynde at skabe?',
        ctaDescription:
            'Prøv Wan 2.6 nu og gør dine ideer til fantastiske videoer',
        ctaButton: 'Prøv Wan 2.6 nu',
        ctaDisclaimer: 'Intet kreditkort kræves — tilmeld dig for at starte',

        // 视频播放相关
        videoNotSupported: 'Din browser understøtter ikke videoafspilning',
        videoLoadingError: 'Kunne ikke indlæse video',
        videoReload: 'Genindlæs',
        },
    no: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 videogenerator - neste generasjon multimodal AI-videoplattform',
        pageDescription:
            'Prøv Wan 2.6, en flaggskip multimodal AI-videomodell. Den leverer filmatisk 1080p-video og et gjennombrudd i innebygd lyd-bildesynk—den genererer bilder sammen med matchende lydeffekter og stemmer i én omgang. Gratis å prøve på 微鲤AI.',
        pageKeywords:
            'Wan 2.6, AI-videogenerator, multimodal AI-videomodell, innebygd lyd-bildesynk, filmatisk 1080p, intelligent storyboarding, gratis AI-video, 微鲤AI, videoproduksjon',

        // 生成器部分
        generatorTitle: 'Wan 2.6 flaggskip multimodal AI-videomodell',
        short_title: 'Multimodal AI-videomodell',
        generatorDescription:
            'Wan 2.6 er den nyeste flaggskip multimodale AI-videomodellen fra Alibaba Clouds Tongyi Wanxiang (Wanx)-team. Som en stor oppgradering i Wan-serien støtter den ikke bare filmatisk 1080p-utgang, men oppnår også et gjennombrudd i innebygd lyd-bildesynk—den genererer bilder sammen med matchende lydeffekter og stemmer i én omgang. Wan 2.6 er bygget for langformat storytelling og har intelligent multi-shot storyboarding som muliggjør opptil 15 sekunder sammenhengende, multikamera skapelse, og hjelper skapere fra manus til ferdig klipp. Prøv Wan 2.6 gratis på 微鲤AI og gå inn i en ny æra av “video med lyd, laget av AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 er nå integrert i 微鲤AI-videogeneratoren for å skape realistiske videoer',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'prøve Wan 2.6 gratis',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 nøkkelfunksjoner',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Innebygd lyd-bildesynk-generering',
        nativeAudioIntegrationDescription:
            'Wan 2.6 bryter grensen mellom syn og lyd—mens videoen genereres kan den automatisk lage presist synkronisert lyd (f.eks. fottrinn, regn) og til og med lip-sync for dialog, slik at du får komplette audiovisuelle assets uten etterdubbing.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Intelligent multi-shot storytelling',
        enhancedDynamicEffectsDescription:
            'Med sterk semantisk forståelse kan modellen dele en kompleks lang prompt i flere shots (f.eks. total til nærbilde) og holde karakteridentitet, scener og lys svært konsistent på tvers av shots—og fortelle en komplett minihistorie i én generering.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performance- og bevegelsesre-enactment',
        preciseCameraControlDescription:
            'Med “video-to-video” kan du laste opp et ekte performanceklipp som referanse. Wan 2.6 kan presist overføre bevegelsesområde, ansiktsuttrykk og til og med kamerarytme til en nygenerert virtuell karakter (f.eks. anime eller 3D), og muliggjøre “AI motion capture”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Sammenhengende 15-sekunders videogenerering',
        enhancedVisualRealismDescription:
            'Generer opptil 15 sekunder 1080p/24fps HD-video. Sammenlignet med korte klipp fra tradisjonelle modeller gir Wan 2.6 mer tid til å skildre komplekse handlinger og miljøendringer, samtidig som visuell kvalitet holdes stabil hele veien.',

        // 如何使用部分
        howToUseTitle: 'Slik bruker du Wan 2.6 på 微鲤AI',
        step1Title: 'Velg en modell',
        step1Description: 'Velg Wan 2.6-modellen i AI Video-verktøyet',
        step2Title: 'Skriv inn innholdet',
        step2Description:
            'Beskriv scenen i tekstfeltet, eller last opp referansebilde/-video for å aktivere “Image to Video” eller “Performance & Motion Re-enactment”.',
        step3Title: 'Generer videoen',
        step3Description:
            'Sett parametre (f.eks. 16:9-format, 15 sekunder varighet), klikk “Generate”, vent litt og forhåndsvis/last ned videoen med lyd.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube-videoer om Wan 2.6-videomodellen',

        // X Posts 部分
        xPostsTitle: 'Trending X-innlegg om Wan 2.6 AI-videomodell',

        // 探索其他模型部分
        exploreModelsTitle: 'Utforsk andre modeller',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Ofte stilte spørsmål',
        faq1Question: 'Hva er Wan 2.6?',
        faq1Answer:
            'Wan 2.6 er Alibaba Clouds nyeste AI-videomodell med filmatisk bildekvalitet, innebygd lyd-bildesynk-generering og intelligent multi-shot storytelling.',
        faq2Question: 'Hva gjør Wan 2.6 spesiell?',
        faq2Answer:
            'Den mest unike funksjonen er “Native Audio-Visual Sync”. Den genererer ikke bare videoen, men produserer også matchende ambient lyd og stemmer samtidig—uten tidkrevende etterdubbing. Den gir også utmerket konsistens på tvers av shots.',
        faq3Question: 'Er Wan 2.6 gratis å bruke på 微鲤AI?',
        faq3Answer:
            '微鲤AI gir gratis kreditter til registrerte brukere for å prøve grunnfunksjonene i Wan 2.6. Generering av HD og lengre (15 sekunder) videoer kan bruke flere kreditter eller kreve oppgradering til Pro.',
        faq4Question: 'Hvor lange er de genererte videoene?',
        faq4Answer:
            'Den støtter for øyeblikket 5 sekunder, 10 sekunder og opptil 15 sekunders klipp. Med multi-shot-funksjonen kan én 15-sekunders generering inneholde rike historiepunkter.',
        faq5Question: 'Hvilke inputmoduser støttes?',
        faq5Answer:
            'Den støtter “Text-to-Video”, “Image-to-Video” og “Video-to-Video” (performance re-enactment), som dekker hele prosessen fra idé til ferdig asset.',
        faq6Question: 'Hva er forskjellen mellom Wan 2.6 og Wan 2.5?',
        faq6Answer:
            'Wan 2.6 er en fullt oppgradert kommersiell (API) versjon: oppløsningen øker fra 720p til 1080p, lydgenerering er lagt til, og bevegelsesglatthet samt prompt-etterlevelse er betydelig forbedret.',

        // CTA 部分
        ctaTitle: 'Klar til å starte?',
        ctaDescription:
            'Prøv Wan 2.6 nå og gjør ideene dine om til fantastiske videoer',
        ctaButton: 'Prøv Wan 2.6 nå',
        ctaDisclaimer: 'Ingen kredittkort nødvendig — registrer deg for å starte',

        // 视频播放相关
        videoNotSupported: 'Nettleseren din støtter ikke videoavspilling',
        videoLoadingError: 'Kunne ikke laste video',
        videoReload: 'Last inn på nytt',
        },
    nl: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 videogenerator - next-gen multimodaal AI-videoplatform',
        pageDescription:
            'Probeer Wan 2.6, een multimodaal AI-videomodel op vlaggenschipniveau. Het levert filmische 1080p-video en een doorbraak in native audio-visuele synchronisatie—genereert beelden samen met bijpassende geluidseffecten en stemmen in één keer. Gratis te proberen op 微鲤AI.',
        pageKeywords:
            'Wan 2.6, AI-videogenerator, multimodaal AI-videomodel, native audio-visuele sync, filmisch 1080p, intelligente storyboarding, gratis AI-video, 微鲤AI, videocreëer',

        // 生成器部分
        generatorTitle: 'Wan 2.6 vlaggenschip multimodaal AI-videomodel',
        short_title: 'Multimodaal AI-videomodel',
        generatorDescription:
            'Wan 2.6 is het nieuwste multimodale AI-videomodel op vlaggenschipniveau van het Tongyi Wanxiang (Wanx)-team van Alibaba Cloud. Als grote upgrade binnen de Wan-serie ondersteunt het niet alleen filmische 1080p-output, maar bereikt het ook een doorbraak in native audio-visuele synchronisatie—beelden worden samen met bijpassende geluidseffecten en stemmen in één keer gegenereerd. Wan 2.6 is gebouwd voor long-form storytelling en heeft intelligente multi-shot storyboarding die tot 15 seconden coherente, multi-camera creatie mogelijk maakt, zodat makers van script tot eindmontage kunnen gaan. Probeer Wan 2.6 gratis op 微鲤AI en stap in een nieuw tijdperk van “video met geluid, gemaakt door AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 is nu geïntegreerd in de 微鲤AI-videogenerator om realistische video\'s te maken',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'Wan 2.6 gratis proberen',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Afbeelding naar video',
        tabTextToVideo: 'Tekst naar video',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 kernfuncties',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Native audio-visuele synchronisatie',
        nativeAudioIntegrationDescription:
            'Wan 2.6 doorbreekt de grens tussen beeld en geluid—tijdens het genereren van de video kan het automatisch precies gesynchroniseerd audio (bijv. voetstappen, regen) en zelfs lip-sync voor dialogen maken, waardoor complete audiovisuele assets ontstaan zonder nabewerking met dubbing.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Intelligente multi-shot storytelling',
        enhancedDynamicEffectsDescription:
            'Met sterke semantische begrip kan het model een complexe lange prompt opdelen in meerdere shots (bijv. wide naar close-up) en de identiteit van personages, scènes en belichting consistent houden—voor een complete miniverhaallijn in één generatie.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performance- en motion re-enactment',
        preciseCameraControlDescription:
            'Met “video-to-video” kun je een echte performanceclip uploaden als referentie. Wan 2.6 kan het bewegingsbereik, gezichtsuitdrukkingen en zelfs het cameraritme nauwkeurig overdragen naar een nieuw gegenereerd virtueel personage (bijv. anime of 3D), waardoor “AI motion capture” mogelijk wordt.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Samenhangende 15-seconden videogenereer',
        enhancedVisualRealismDescription:
            'Genereer tot 15 seconden 1080p/24fps HD-video. Vergeleken met korte clips van traditionele modellen geeft Wan 2.6 meer tijd om complexe acties en omgevingsveranderingen te tonen, terwijl de visuele kwaliteit stabiel blijft.',

        // 如何使用部分
        howToUseTitle: 'Zo gebruik je Wan 2.6 op 微鲤AI',
        step1Title: 'Kies een model',
        step1Description: 'Selecteer het Wan 2.6-model in de AI Video-tool',
        step2Title: 'Voer je content in',
        step2Description:
            'Beschrijf de scène in het tekstvak, of upload een referentie-afbeelding/-video om “Image to Video” of “Performance & Motion Re-enactment” te gebruiken.',
        step3Title: 'Genereer de video',
        step3Description:
            'Stel parameters in (bijv. 16:9-beeldverhouding, 15 seconden), klik “Generate” en wacht even om je video met geluid te previewen en te downloaden.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube-video\'s over het Wan 2.6-videomodel',

        // X Posts 部分
        xPostsTitle: 'Trending X-berichten over het Wan 2.6 AI-videomodel',

        // 探索其他模型部分
        exploreModelsTitle: 'Ontdek andere modellen',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Veelgestelde vragen',
        faq1Question: 'Wat is Wan 2.6?',
        faq1Answer:
            'Wan 2.6 is Alibaba Cloud’s nieuwste AI-videomodel met filmische beeldkwaliteit, native audio-visuele synchronisatie en intelligente multi-shot storytelling.',
        faq2Question: 'Wat maakt Wan 2.6 bijzonder?',
        faq2Answer:
            'De opvallende feature is “Native Audio-Visual Sync”. Het genereert niet alleen video, maar ook bijpassend omgevingsgeluid en stemmen tegelijk—zonder tijdrovende nabehandeling met dubbing. Het levert ook uitstekende multi-shot consistentie.',
        faq3Question: 'Is Wan 2.6 gratis te gebruiken op 微鲤AI?',
        faq3Answer:
            '微鲤AI geeft gratis credits voor geregistreerde gebruikers om de basisfuncties van Wan 2.6 te proberen. HD en langere (15 seconden) video’s kunnen meer credits verbruiken of een Pro-upgrade vereisen.',
        faq4Question: 'Hoe lang zijn de gegenereerde video\'s?',
        faq4Answer:
            'Het ondersteunt momenteel clips van 5, 10 en tot 15 seconden. Met de multi-shot feature kan één generatie van 15 seconden rijke verhaalbeats bevatten.',
        faq5Question: 'Welke inputmodi ondersteunt het?',
        faq5Answer:
            'Het ondersteunt “Text-to-Video”, “Image-to-Video” en “Video-to-Video” (performance re-enactment), en dekt het hele proces van idee tot asset.',
        faq6Question: 'Wat is het verschil tussen Wan 2.6 en Wan 2.5?',
        faq6Answer:
            'Wan 2.6 is een volledig geüpgrade commerciële (API) versie: de resolutie gaat van 720p naar 1080p, audiogeneratie is toegevoegd en bewegingsvloeiendheid en prompt-following zijn sterk verbeterd.',

        // CTA 部分
        ctaTitle: 'Klaar om te beginnen?',
        ctaDescription:
            'Probeer Wan 2.6 nu en zet je ideeën om in geweldige video\'s',
        ctaButton: 'Probeer Wan 2.6 nu',
        ctaDisclaimer: 'Geen creditcard nodig — meld je aan om te starten',

        // 视频播放相关
        videoNotSupported: 'Je browser ondersteunt geen video-afspeling',
        videoLoadingError: 'Video laden mislukt',
        videoReload: 'Opnieuw laden',
        },
    id: {
        // 页面标题和描述
        pageTitle:
            'Generator Video Wan 2.6 - Platform Pembuatan Video AI Multimodal Generasi Baru',
        pageDescription:
            'Coba Wan 2.6, model generasi video AI multimodal flagship. Menghasilkan video sinematik 1080p dan terobosan Native Audio-Visual Sync—menghasilkan visual bersama efek suara dan suara yang cocok dalam sekali proses. Gratis dicoba di 微鲤AI.',
        pageKeywords:
            'Wan 2.6, generator video AI, model video AI multimodal, sinkron audio-visual native, 1080p sinematik, storyboarding cerdas, video AI gratis, 微鲤AI, pembuatan video',

        // 生成器部分
        generatorTitle: 'Model Generasi Video AI Multimodal Flagship Wan 2.6',
        short_title: 'Model Video AI Multimodal',
        generatorDescription:
            'Wan 2.6 adalah model generasi video AI multimodal flagship terbaru dari tim Tongyi Wanxiang (Wanx) Alibaba Cloud. Sebagai peningkatan besar di seri Wan, model ini tidak hanya mendukung output sinematik 1080p, tetapi juga menghadirkan terobosan Native Audio-Visual Sync—menghasilkan visual bersama efek suara dan suara yang cocok dalam sekali proses. Dibangun untuk storytelling berdurasi panjang, Wan 2.6 memiliki storyboarding multi-shot cerdas yang memungkinkan hingga 15 detik kreasi multi-kamera yang koheren, membantu kreator dari skrip hingga final cut. Coba Wan 2.6 gratis di 微鲤AI dan masuk ke era baru “video dengan suara, dibuat oleh AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 kini terintegrasi di generator video 微鲤AI untuk membuat video realistis',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'coba Wan 2.6 gratis',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // 核心功能部分
        coreFeaturesTitle: 'Fitur Utama Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Generasi Sinkron Audio-Visual Native',
        nativeAudioIntegrationDescription:
            'Wan 2.6 menembus batas antara visual dan audio—saat menghasilkan video, ia dapat otomatis membuat audio yang tersinkron presisi (misalnya langkah kaki, hujan) bahkan lip-sync dialog karakter, sehingga menghasilkan aset audiovisual lengkap tanpa dubbing pasca-produksi.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Storytelling Multi-Shot Cerdas',
        enhancedDynamicEffectsDescription:
            'Dengan pemahaman semantik yang kuat, model dapat memecah prompt panjang yang kompleks menjadi beberapa shot (misalnya wide ke close-up) dan menjaga identitas karakter, adegan, serta pencahayaan tetap konsisten—menceritakan mini-story lengkap dalam satu generasi.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Re-enactment Performa & Gerak',
        preciseCameraControlDescription:
            'Dengan “video-to-video”, Anda dapat mengunggah klip performa nyata sebagai referensi. Wan 2.6 dapat mentransfer rentang gerak, ekspresi wajah, bahkan ritme kamera secara akurat ke karakter virtual baru (misalnya anime atau 3D), memungkinkan “AI motion capture”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Generasi Video 15 Detik yang Koheren',
        enhancedVisualRealismDescription:
            'Hasilkan hingga 15 detik video HD 1080p/24fps. Dibanding klip pendek dari model tradisional, Wan 2.6 memberi lebih banyak waktu untuk menggambarkan aksi kompleks dan perubahan lingkungan sambil mempertahankan kualitas visual yang stabil.',

        // 如何使用部分
        howToUseTitle: 'Cara Menggunakan Wan 2.6 di 微鲤AI',
        step1Title: 'Pilih Model',
        step1Description: 'Pilih model Wan 2.6 di alat AI Video',
        step2Title: 'Masukkan Konten Anda',
        step2Description:
            'Jelaskan adegan yang diinginkan di kotak teks, atau unggah gambar/video referensi untuk mengaktifkan “Image to Video” atau “Performance & Motion Re-enactment”.',
        step3Title: 'Buat Video',
        step3Description:
            'Atur parameter (misalnya rasio 16:9, durasi 15 detik), klik “Generate”, lalu tunggu untuk pratinjau dan unduh video dengan suara.',

        // YouTube 视频部分
        youtubeTitle: 'Video YouTube tentang Model Video Wan 2.6',

        // X Posts 部分
        xPostsTitle: 'Posting X Tren tentang Model Video AI Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'Jelajahi Model Lain',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Pertanyaan yang Sering Diajukan',
        faq1Question: 'Apa itu Wan 2.6?',
        faq1Answer:
            'Wan 2.6 adalah model generasi video AI terbaru dari Alibaba Cloud, dengan visual berkualitas sinematik, generasi sinkron audio-visual native, dan storytelling multi-shot cerdas.',
        faq2Question: 'Apa yang membuat Wan 2.6 spesial?',
        faq2Answer:
            'Fitur utamanya adalah “Native Audio-Visual Sync”. Bukan hanya menghasilkan video, tetapi juga menghasilkan suara lingkungan dan suara yang cocok secara bersamaan—menghilangkan dubbing pasca-produksi yang rumit. Konsistensi multi-shot juga sangat baik.',
        faq3Question: 'Apakah Wan 2.6 gratis digunakan di 微鲤AI?',
        faq3Answer:
            '微鲤AI menyediakan kredit gratis bagi pengguna terdaftar untuk mencoba fitur dasar Wan 2.6. Generasi video HD yang lebih panjang (15 detik) dapat menghabiskan lebih banyak kredit atau memerlukan upgrade ke Pro.',
        faq4Question: 'Berapa durasi video yang dihasilkan?',
        faq4Answer:
            'Saat ini mendukung klip 5 detik, 10 detik, dan hingga 15 detik. Dengan fitur multi-shot, satu generasi 15 detik dapat mencakup alur cerita yang kaya.',
        faq5Question: 'Mode input apa yang didukung?',
        faq5Answer:
            'Mendukung “Text-to-Video”, “Image-to-Video”, dan “Video-to-Video” (performance re-enactment), mencakup proses end-to-end dari ide hingga aset.',
        faq6Question: 'Apa perbedaan Wan 2.6 dan Wan 2.5?',
        faq6Answer:
            'Wan 2.6 adalah versi komersial (API) yang sepenuhnya ditingkatkan: resolusi naik dari 720p ke 1080p, generasi audio ditambahkan, dan kelancaran gerak serta kepatuhan prompt meningkat signifikan.',

        // CTA 部分
        ctaTitle: 'Siap mulai berkarya?',
        ctaDescription:
            'Coba Wan 2.6 sekarang dan ubah ide Anda menjadi video yang menakjubkan',
        ctaButton: 'Coba Wan 2.6 Sekarang',
        ctaDisclaimer: 'Tidak perlu kartu kredit — daftar untuk mulai',

        // 视频播放相关
        videoNotSupported: 'Browser Anda tidak mendukung pemutaran video',
        videoLoadingError: 'Gagal memuat video',
        videoReload: 'Muat ulang',
        },
    tr: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 Video Üretici - Yeni Nesil Çok Modlu AI Video Platformu',
        pageDescription:
            'Wan 2.6’yı deneyin: amiral gemisi çok modlu AI video üretim modeli. Sinematik 1080p video ve Native Audio-Visual Sync ile çığır açar—görüntüleri, uyumlu efektler ve seslerle tek seferde üretir. 微鲤AI’de ücretsiz deneyin.',
        pageKeywords:
            'Wan 2.6, AI video üretici, çok modlu AI video modeli, yerleşik ses-görüntü senkronu, sinematik 1080p, akıllı storyboarding, ücretsiz AI video, 微鲤AI, video üretimi',

        // 生成器部分
        generatorTitle: 'Wan 2.6 Amiral Gemisi Çok Modlu AI Video Modeli',
        short_title: 'Çok Modlu AI Video Modeli',
        generatorDescription:
            'Wan 2.6, Alibaba Cloud’un Tongyi Wanxiang (Wanx) ekibi tarafından yayımlanan en yeni amiral gemisi çok modlu AI video üretim modelidir. Wan serisindeki büyük bir yükseltme olarak yalnızca sinematik 1080p çıktı sunmakla kalmaz, Native Audio-Visual Sync ile de bir atılım sağlar—görüntüleri uyumlu efektler ve seslerle tek seferde üretir. Uzun form hikâye anlatımı için tasarlanan Wan 2.6, 15 saniyeye kadar tutarlı, çok kameralı üretime olanak tanıyan akıllı multi-shot storyboarding sunar; yaratıcıların senaryodan final kurgusuna geçmesine yardımcı olur. 微鲤AI’de Wan 2.6’yı ücretsiz deneyin ve “AI tarafından üretilen, sesli video” çağını başlatın.',
        generatorDescriptionHighlight1:
            'Wan 2.6 artık gerçekçi videolar üretmek için 微鲤AI video üreticisine entegre edildi',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'Wan 2.6’yı ücretsiz dene',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Görselden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 Temel Özellikler',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Yerleşik Ses-Görüntü Senkron Üretimi',
        nativeAudioIntegrationDescription:
            'Wan 2.6, görüntü ve ses arasındaki sınırı kaldırır—video üretirken otomatik olarak hassas senkronlu ses (ör. ayak sesi, yağmur) ve hatta karakter diyaloglarına lip-sync üretir; ek dublaj olmadan tam görsel-işitsel çıktı sağlar.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Akıllı Multi-Shot Hikâye Anlatımı',
        enhancedDynamicEffectsDescription:
            'Güçlü anlamsal anlayışla model, karmaşık uzun promptları birden çok shot’a bölebilir (ör. genişten yakın plana) ve karakter kimliğini, sahneleri ve ışığı tutarlı biçimde koruyarak tek üretimde bütün bir mini hikâye anlatır.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performans ve Hareket Yeniden Canlandırma',
        preciseCameraControlDescription:
            '“Video-to-video” kullanarak gerçek bir performans klibini referans olarak yükleyebilirsiniz. Wan 2.6, hareket aralığını, yüz ifadelerini ve hatta kamera ritmini yeni üretilen sanal karaktere (ör. anime veya 3D) doğru şekilde aktararak “AI motion capture” sağlar.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Tutarlı 15 Saniyelik Video Üretimi',
        enhancedVisualRealismDescription:
            '1080p/24fps HD videoda 15 saniyeye kadar üretim yapın. Geleneksel modellerdeki kısa kliplere kıyasla Wan 2.6, karmaşık eylemleri ve çevresel değişimleri daha uzun süre anlatırken görsel kaliteyi istikrarlı tutar.',

        // 如何使用部分
        howToUseTitle: '微鲤AI’de Wan 2.6 Nasıl Kullanılır',
        step1Title: 'Model Seçin',
        step1Description: 'AI Video aracında Wan 2.6 modelini seçin',
        step2Title: 'İçeriğinizi Girin',
        step2Description:
            'Metin kutusunda istediğiniz sahneyi anlatın veya “Image to Video” ya da “Performance & Motion Re-enactment” için referans görsel/video yükleyin.',
        step3Title: 'Videoyu Üretin',
        step3Description:
            'Parametreleri ayarlayın (ör. 16:9 en-boy oranı, 15 saniye süre), “Generate”e tıklayın, ardından sesli videoyu önizleyip indirmeniz için kısa süre bekleyin.',

        // YouTube 视频部分
        youtubeTitle: 'Wan 2.6 Video Modeli Hakkında YouTube Videoları',

        // X Posts 部分
        xPostsTitle: 'Wan 2.6 AI Video Modeli Hakkında Trend X Paylaşımları',

        // 探索其他模型部分
        exploreModelsTitle: 'Diğer Modelleri Keşfet',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Sıkça Sorulan Sorular',
        faq1Question: 'Wan 2.6 nedir?',
        faq1Answer:
            'Wan 2.6, Alibaba Cloud’un sinematik kalitede görseller, yerleşik ses-görüntü senkronu ve akıllı multi-shot hikâye anlatımı sunan en yeni AI video üretim modelidir.',
        faq2Question: 'Wan 2.6’yı özel kılan nedir?',
        faq2Answer:
            'Öne çıkan özellik “Native Audio-Visual Sync”tir. Sadece video üretmez; aynı anda uyumlu ortam sesi ve sesleri de üretir—zahmetli sonradan dublajı ortadan kaldırır. Ayrıca mükemmel multi-shot tutarlılığı sağlar.',
        faq3Question: 'Wan 2.6 微鲤AI’de ücretsiz mi?',
        faq3Answer:
            '微鲤AI, kayıtlı kullanıcıların Wan 2.6’nın temel özelliklerini denemesi için ücretsiz kredi sağlar. HD ve daha uzun (15 saniye) videolar daha fazla kredi tüketebilir veya Pro yükseltmesi gerektirebilir.',
        faq4Question: 'Üretilen videoların süresi ne kadar?',
        faq4Answer:
            'Şu anda 5 saniye, 10 saniye ve 15 saniyeye kadar klipleri destekler. Multi-shot özelliğiyle tek bir 15 saniyelik üretim zengin hikâye anları içerebilir.',
        faq5Question: 'Hangi giriş modlarını destekler?',
        faq5Answer:
            '“Text-to-Video”, “Image-to-Video” ve “Video-to-Video” (performans yeniden canlandırma) modlarını destekler; fikirden nihai çıktıya kadar uçtan uca üretimi kapsar.',
        faq6Question: 'Wan 2.6 ile Wan 2.5 arasındaki fark nedir?',
        faq6Answer:
            'Wan 2.6, tamamen yükseltilmiş ticari (API) sürümdür: çözünürlük 720p’den 1080p’ye çıkar, ses üretimi eklenir ve hareket akıcılığı ile prompt uyumu önemli ölçüde iyileştirilir.',

        // CTA 部分
        ctaTitle: 'Oluşturmaya hazır mısınız?',
        ctaDescription:
            'Wan 2.6’yı şimdi deneyin ve fikirlerinizi harika videolara dönüştürün',
        ctaButton: 'Wan 2.6’yı şimdi dene',
        ctaDisclaimer: 'Kredi kartı gerekmez — başlamak için kaydolun',

        // 视频播放相关
        videoNotSupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoLoadingError: 'Video yüklenemedi',
        videoReload: 'Yeniden yükle',
    },
}
